// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 fill=%27rgb%28255, 255, 255%29%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 fill=%27rgb%2859, 67, 82%29%27 viewBox=%270 0 16 16%27><path d=%27M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 fill=%27rgb%281, 102, 165%29%27 viewBox=%270 0 16 16%27><path d=%27M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 fill=%27rgb%28230, 232, 229%29%27 viewBox=%270 0 16 16%27><path d=%27M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 fill=%27rgb%2859, 67, 82%29%27 viewBox=%270 0 16 16%27%3E%3Cpath fill-rule=%27evenodd%27 d=%27M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 fill=%27rgb%28255, 255, 255%29%27 viewBox=%270 0 16 16%27%3E%3Cpath fill-rule=%27evenodd%27 d=%27M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 fill=%27rgb%28255, 255, 255%29%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M8.5.5a.5.5 0 0 0-1 0v.518A7 7 0 0 0 1.018 7.5H.5a.5.5 0 0 0 0 1h.518A7 7 0 0 0 7.5 14.982v.518a.5.5 0 0 0 1 0v-.518A7 7 0 0 0 14.982 8.5h.518a.5.5 0 0 0 0-1h-.518A7 7 0 0 0 8.5 1.018zm-6.48 7A6 6 0 0 1 7.5 2.02v.48a.5.5 0 0 0 1 0v-.48a6 6 0 0 1 5.48 5.48h-.48a.5.5 0 0 0 0 1h.48a6 6 0 0 1-5.48 5.48v-.48a.5.5 0 0 0-1 0v.48A6 6 0 0 1 2.02 8.5h.48a.5.5 0 0 0 0-1zM8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 fill=%27rgb%28255, 255, 255%29%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z%27/%3E%3Cpath fill-rule=%27evenodd%27 d=%27M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 fill=%27rgb%28255, 255, 255%29%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 fill=%27rgb%28255, 255, 255%29%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z%27/%3E%3Cpath d=%27M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 fill=%27rgb%28255, 255, 255%29%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M8.235 1.559a.5.5 0 0 0-.47 0l-7.5 4a.5.5 0 0 0 0 .882L3.188 8 .264 9.559a.5.5 0 0 0 0 .882l7.5 4a.5.5 0 0 0 .47 0l7.5-4a.5.5 0 0 0 0-.882L12.813 8l2.922-1.559a.5.5 0 0 0 0-.882zm3.515 7.008L14.438 10 8 13.433 1.562 10 4.25 8.567l3.515 1.874a.5.5 0 0 0 .47 0zM8 9.433 1.562 6 8 2.567 14.438 6z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 fill=%27rgb%28255, 255, 255%29%27 viewBox=%270 0 16 16%27%3E%3Cpath fill-rule=%27evenodd%27 d=%27M8 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999zm2.493 8.574a.5.5 0 0 1-.411.575c-.712.118-1.28.295-1.655.493a1.319 1.319 0 0 0-.37.265.301.301 0 0 0-.057.09V14l.002.008a.147.147 0 0 0 .016.033.617.617 0 0 0 .145.15c.165.13.435.27.813.395.751.25 1.82.414 3.024.414s2.273-.163 3.024-.414c.378-.126.648-.265.813-.395a.619.619 0 0 0 .146-.15.148.148 0 0 0 .015-.033L12 14v-.004a.301.301 0 0 0-.057-.09 1.318 1.318 0 0 0-.37-.264c-.376-.198-.943-.375-1.655-.493a.5.5 0 1 1 .164-.986c.77.127 1.452.328 1.957.594C12.5 13 13 13.4 13 14c0 .426-.26.752-.544.977-.29.228-.68.413-1.116.558-.878.293-2.059.465-3.34.465-1.281 0-2.462-.172-3.34-.465-.436-.145-.826-.33-1.116-.558C3.26 14.752 3 14.426 3 14c0-.599.5-1 .961-1.243.505-.266 1.187-.467 1.957-.594a.5.5 0 0 1 .575.411z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 fill=%27rgb%28255, 255, 255%29%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z%27/%3E%3Cpath d=%27M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
#map {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  /* Microsoft Edge */
  /* Disable blue-highlight on touch devices */
  @import url("https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap");
}
#map .oltb-animation {
  animation-duration: 250ms;
  animation-timing-function: linear;
  animation-delay: 0;
  animation-iteration-count: 1;
  animation-direction: normal;
  animation-fill-mode: forwards;
  animation-play-state: running;
}
#map .oltb-animation--linear-spinner {
  animation-name: oltb-spinner;
  animation-duration: 1500ms;
  animation-iteration-count: infinite;
}
#map .oltb-animation--bouncy-spinner {
  animation-name: oltb-spinner;
  animation-duration: 1500ms;
  animation-iteration-count: infinite;
}
#map .oltb-animation--slide-in {
  animation-name: oltb-slide-in;
}
#map .oltb-animation--slide-out {
  animation-name: oltb-slide-out;
}
#map .oltb-animation--bounce {
  animation-name: oltb-bounce;
}
#map .oltb-animation--centered-bounce {
  animation-name: oltb-centered-bounce;
}
@keyframes oltb-spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes oltb-slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes oltb-slide-out {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(100%);
  }
}
@keyframes oltb-bounce {
  0% {
    transform: scale(0.95);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes oltb-centered-bounce {
  0% {
    transform: scale(0.95) translateX(-52.5%);
  }
  50% {
    transform: scale(1.05) translateX(-47.5%);
  }
  100% {
    transform: scale(1) translateX(-50%);
  }
}
#map *,
#map *::before,
#map *::after {
  box-sizing: border-box;
  outline: none;
}
#map p {
  font-size: 1.125rem;
}
#map textarea {
  resize: none;
}
#map ::placeholder {
  color: #364159;
  opacity: 1;
}
#map ::-ms-input-placeholder {
  color: #364159;
  opacity: 1;
}
#map .oltb-btn,
#map .oltb-func-btn,
#map .oltb-toggleable {
  -webkit-tap-highlight-color: transparent;
}
#map .oltb-btn:focus,
#map .oltb-func-btn:focus,
#map .oltb-toggleable:focus {
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
  outline: none;
}
#map .oltb-m-0 {
  margin: 0 !important;
}
#map .oltb-mt-025 {
  margin-top: 0.25rem !important;
}
#map .oltb-mt-0313 {
  margin-top: 0.313rem !important;
}
#map .oltb-mt-05 {
  margin-top: 0.5rem !important;
}
#map .oltb-mt-0625 {
  margin-top: 0.625rem !important;
}
#map .oltb-mt-1 {
  margin-top: 1rem !important;
}
#map .oltb-mt-15 {
  margin-top: 1.5rem !important;
}
#map .oltb-mb-025 {
  margin-bottom: 0.25rem !important;
}
#map .oltb-mb-0313 {
  margin-bottom: 0.313rem !important;
}
#map .oltb-mb-05 {
  margin-bottom: 0.5rem !important;
}
#map .oltb-mb-0625 {
  margin-bottom: 0.625rem !important;
}
#map .oltb-mb-1 {
  margin-bottom: 1rem !important;
}
#map .oltb-mb-15 {
  margin-bottom: 1.5rem !important;
}
#map .oltb-ml-025 {
  margin-left: 0.25rem !important;
}
#map .oltb-ml-0313 {
  margin-left: 0.313rem !important;
}
#map .oltb-ml-05 {
  margin-left: 0.5rem !important;
}
#map .oltb-ml-0625 {
  margin-left: 0.625rem !important;
}
#map .oltb-ml-1 {
  margin-left: 1rem !important;
}
#map .oltb-ml-15 {
  margin-left: 1.5rem !important;
}
#map .oltb-mr-025 {
  margin-right: 0.25rem !important;
}
#map .oltb-mr-0313 {
  margin-right: 0.313rem !important;
}
#map .oltb-mr-05 {
  margin-right: 0.5rem !important;
}
#map .oltb-mr-0625 {
  margin-right: 0.625rem !important;
}
#map .oltb-mr-1 {
  margin-right: 1rem !important;
}
#map .oltb-mr-15 {
  margin-right: 1.5rem !important;
}
#map .oltb-group {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
}
#map .oltb-group > * {
  flex: 1 1;
}
#map .oltb-w-100 {
  width: 100% !important;
}
#map .oltb-d-none {
  display: none !important;
}
#map .oltb-d-flex {
  display: flex !important;
}
#map .oltb-flex-content-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
#map .oltb-text-center {
  text-align: center;
}
#map .oltb-justify-content-between {
  justify-content: space-between;
}
#map .oltb-justify-content-center {
  justify-content: center;
}
#map .oltb-hide-scrollbars {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
#map .oltb-hide-scrollbars::-webkit-scrollbar {
  display: none;
}
#map .oltb-thin-scrollbars {
  -ms-overflow-style: none;
  scrollbar-width: thin;
  scrollbar-color: #cdcdcd #f0f0f0;
}
#map .oltb-thin-scrollbars::-webkit-scrollbar {
  width: 0.5rem;
  height: 0.5rem;
  background: #f0f0f0;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
#map .oltb-thin-scrollbars::-webkit-scrollbar-thumb {
  background-color: #cdcdcd;
  border-radius: 1.5rem;
}
#map .oltb-thin-scrollbars::-webkit-scrollbar-thumb:hover {
  background-color: #cdcdcd;
}
#map .oltb-link {
  color: #0099ff;
}
#map .oltb-link:focus {
  text-decoration: underline;
}
#map html,
#map body {
  margin: 0;
  height: 100%;
  font-family: "Roboto", sans-serif;
}
#map #map {
  width: 100%;
  height: 100%;
  background-color: #aad3df;
  position: absolute;
  overflow: hidden;
  -webkit-user-select: none;
          user-select: none;
}
#map .oltb-label {
  display: block;
  color: #364159;
  margin-bottom: 0.25rem;
}
#map .oltb-label--clickable {
  cursor: pointer;
}
#map .oltb-label--inline {
  display: inline;
}
#map .oltb-label--inline-block {
  display: inline-block;
}
#map body.oltb-dark .oltb-label {
  color: #ffffff;
}
#map .oltb-hide {
  display: none !important;
}
#map .oltb-select {
  display: block;
  width: 100%;
  min-width: 150px;
  padding: 0.25rem 2.25rem 0.25rem 0.5rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #191e29;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  background-color: #f3f4f5;
  border: 1px solid #ced4da;
  border-radius: 4px;
  appearance: none;
  word-wrap: normal;
  outline: none;
}
#map .oltb-select:focus {
  border: 1px solid rgba(99, 151, 194, 0.5);
  box-shadow: 0 0 0 3px rgba(99, 151, 194, 0.3);
}
#map .oltb-select:disabled {
  background-color: rgba(211, 217, 230, 0.5);
  cursor: not-allowed;
}
#map body.oltb-dark .oltb-select {
  background-color: #959dad;
  border: 1px solid #2f3642;
}
#map body.oltb-dark .oltb-select:focus {
  box-shadow: 0 0 0 3px rgba(149, 157, 173, 0.5);
}
#map body.oltb-dark .oltb-select:disabled {
  background-color: rgba(149, 157, 173, 0.3);
}
#map .oltb-input {
  display: block;
  width: 100%;
  min-width: 150px;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #191e29;
  background-clip: padding-box;
  background-color: #f3f4f5;
  border: 1px solid #ced4da;
  appearance: none;
  border-radius: 4px;
  transition: border-color 150ms ease-in-out, box-shadow 150ms ease-in-out;
  outline: none;
}
#map .oltb-input:focus {
  border: 1px solid rgba(99, 151, 194, 0.5);
  box-shadow: 0 0 0 3px rgba(99, 151, 194, 0.3);
}
#map .oltb-input:disabled {
  background-color: rgba(211, 217, 230, 0.5);
  cursor: not-allowed;
}
#map .oltb-input-button-group {
  display: flex;
  justify-content: space-evenly;
}
#map .oltb-input-button-group .oltb-input {
  margin-right: 0.5rem;
}
#map body.oltb-dark .oltb-input {
  background-color: #959dad;
  border: 1px solid #2f3642;
}
#map body.oltb-dark .oltb-input:focus {
  box-shadow: 0 0 0 3px rgba(149, 157, 173, 0.3);
}
#map body.oltb-dark .oltb-input:disabled {
  background-color: rgba(149, 157, 173, 0.3);
}
#map .oltb-btn {
  display: inline-flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  font-weight: 400;
  text-align: center;
  box-shadow: 1px 1px 0 rgba(0, 0, 0, 0.2);
  text-shadow: 1px 1px 0 rgba(0, 0, 0, 0.1);
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  padding: 0.5rem;
  color: #ffffff;
  background-color: transparent;
}
#map .oltb-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
#map .oltb-btn__icon {
  filter: drop-shadow(1px 1px 0 rgba(0, 0, 0, 0.1));
}
#map .oltb-btn--round {
  border-radius: 50%;
}
#map .oltb-btn--blank {
  box-shadow: none;
  padding: 0;
}
#map .oltb-btn--blue-light {
  background-color: #d7e3fa;
}
#map .oltb-btn--blue-light:focus {
  box-shadow: 0 0 0 3px rgba(215, 227, 250, 0.5);
}
#map .oltb-btn--blue-mid {
  background-color: #6397c2;
}
#map .oltb-btn--blue-mid:focus {
  box-shadow: 0 0 0 3px rgba(99, 151, 194, 0.5);
}
#map .oltb-btn--blue-dark {
  background-color: #0166a5;
}
#map .oltb-btn--blue-dark:focus {
  box-shadow: 0 0 0 3px rgba(1, 102, 165, 0.5);
}
#map .oltb-btn--green-light {
  background-color: #bcfaf4;
}
#map .oltb-btn--green-light:focus {
  box-shadow: 0 0 0 3px rgba(188, 250, 244, 0.5);
}
#map .oltb-btn--green-mid {
  background-color: #3caea3;
}
#map .oltb-btn--green-mid:focus {
  box-shadow: 0 0 0 3px rgba(60, 174, 163, 0.5);
}
#map .oltb-btn--green-dark {
  background-color: #007c70;
}
#map .oltb-btn--green-dark:focus {
  box-shadow: 0 0 0 3px rgba(0, 124, 112, 0.5);
}
#map .oltb-btn--red-light {
  background-color: #fdb5b4;
}
#map .oltb-btn--red-light:focus {
  box-shadow: 0 0 0 3px rgba(253, 181, 180, 0.5);
}
#map .oltb-btn--red-mid {
  background-color: #e96b69;
}
#map .oltb-btn--red-mid:focus {
  box-shadow: 0 0 0 3px rgba(233, 107, 105, 0.5);
}
#map .oltb-btn--red-dark {
  background-color: #d64b49;
}
#map .oltb-btn--red-dark:focus {
  box-shadow: 0 0 0 3px rgba(214, 75, 73, 0.5);
}
#map .oltb-btn--gray-light {
  background-color: #d3d9e6;
}
#map .oltb-btn--gray-light:focus {
  box-shadow: 0 0 0 3px rgba(211, 217, 230, 0.5);
}
#map .oltb-btn--gray-mid {
  background-color: #959dad;
}
#map .oltb-btn--gray-mid:focus {
  box-shadow: 0 0 0 3px rgba(149, 157, 173, 0.5);
}
#map .oltb-btn--gray-dark {
  background-color: #364159;
}
#map .oltb-btn--gray-dark:focus {
  box-shadow: 0 0 0 3px rgba(54, 65, 89, 0.5);
}
#map body.oltb-using-keyboard .oltb-btn--blank:focus {
  box-shadow: 0 0 0 3px rgba(149, 157, 173, 0.5);
}
#map .oltb-checkbox-wrapper {
  display: flex;
  align-items: center;
}
#map .oltb-checkbox-wrapper--margin {
  margin-bottom: 1rem;
}
#map .oltb-checkbox-wrapper:last-child {
  margin-bottom: 0;
}
#map .oltb-checkbox-wrapper__checkbox {
  margin: 0.25rem 0.625rem 0.25rem 0;
  width: 1.25rem;
  height: 1.25rem;
  flex-shrink: 0;
  background-color: #ffffff;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid #ced4da;
  appearance: none;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
  border-radius: 4px;
  transition: border-color 150ms ease-in-out, box-shadow 150ms ease-in-out;
}
#map .oltb-checkbox-wrapper__checkbox:checked {
  background-color: #6397c2;
  border-color: #6397c2;
}
#map .oltb-checkbox-wrapper__checkbox:checked[type=checkbox] {
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
#map .oltb-checkbox-wrapper__checkbox:focus {
  border: 1px solid #6397c2;
  box-shadow: 0 0 0 3px rgba(99, 151, 194, 0.3);
}
#map body.oltb-dark .oltb-checkbox-wrapper__title {
  color: #ffffff;
}
#map body.oltb-dark .oltb-checkbox-wrapper__checkbox {
  background-color: #959dad;
  border: none;
}
#map body.oltb-dark .oltb-checkbox-wrapper__checkbox:checked {
  background-color: #6397c2;
}
#map body.oltb-dark .oltb-checkbox-wrapper__checkbox:focus {
  border: none;
  box-shadow: 0 0 0 3px rgba(215, 227, 250, 0.7);
}
#map .oltb-slider {
  appearance: none;
  -webkit-appearance: none;
  width: 100%;
  height: 0;
  outline: none;
  position: absolute;
  z-index: 700;
  top: 50%;
  left: 0;
  right: 0;
  margin: 0;
  display: none;
}
#map .oltb-slider--show {
  display: block;
}
#map .oltb-slider::-webkit-slider-thumb {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background-color: #6397c2;
  cursor: move;
  box-shadow: 0 0 0 8px rgba(255, 255, 255, 0.9);
  filter: drop-shadow(1px 1px 0 rgba(0, 0, 0, 0.2));
  border: none;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 24px 24px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  -webkit-appearance: none;
}
#map .oltb-slider::-moz-range-thumb {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background-color: #6397c2;
  cursor: move;
  box-shadow: 0 0 0 8px rgba(255, 255, 255, 0.9);
  filter: drop-shadow(1px 1px 0 rgba(0, 0, 0, 0.2));
  border: none;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 24px 24px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
#map .oltb-chip {
  display: inline-flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  font-weight: 400;
  text-align: center;
  text-shadow: 1px 1px 0 rgba(0, 0, 0, 0.1);
  border: none;
  border-radius: 1rem;
  font-size: 1rem;
  padding: 0.5rem;
  color: #ffffff;
  background-color: transparent;
  margin: 0.5rem 0;
}
#map .oltb-chip:last-child {
  margin-right: 0.5rem;
}
#map .oltb-chip--deactivated {
  text-decoration: line-through;
  font-style: italic;
}
#map .oltb-chip--blue-light {
  background-color: #d7e3fa;
}
#map .oltb-chip--blue-light:focus {
  box-shadow: 0 0 0 3px rgba(215, 227, 250, 0.5);
}
#map .oltb-chip--blue-mid {
  background-color: #6397c2;
}
#map .oltb-chip--blue-mid:focus {
  box-shadow: 0 0 0 3px rgba(99, 151, 194, 0.5);
}
#map .oltb-chip--blue-dark {
  background-color: #0166a5;
}
#map .oltb-chip--blue-dark:focus {
  box-shadow: 0 0 0 3px rgba(1, 102, 165, 0.5);
}
#map .oltb-chip--green-light {
  background-color: #bcfaf4;
}
#map .oltb-chip--green-light:focus {
  box-shadow: 0 0 0 3px rgba(188, 250, 244, 0.5);
}
#map .oltb-chip--green-mid {
  background-color: #3caea3;
}
#map .oltb-chip--green-mid:focus {
  box-shadow: 0 0 0 3px rgba(60, 174, 163, 0.5);
}
#map .oltb-chip--green-dark {
  background-color: #007c70;
}
#map .oltb-chip--green-dark:focus {
  box-shadow: 0 0 0 3px rgba(0, 124, 112, 0.5);
}
#map .oltb-chip--red-light {
  background-color: #fdb5b4;
}
#map .oltb-chip--red-light:focus {
  box-shadow: 0 0 0 3px rgba(253, 181, 180, 0.5);
}
#map .oltb-chip--red-mid {
  background-color: #e96b69;
}
#map .oltb-chip--red-mid:focus {
  box-shadow: 0 0 0 3px rgba(233, 107, 105, 0.5);
}
#map .oltb-chip--red-dark {
  background-color: #d64b49;
}
#map .oltb-chip--red-dark:focus {
  box-shadow: 0 0 0 3px rgba(214, 75, 73, 0.5);
}
#map .oltb-chip--gray-light {
  background-color: #d3d9e6;
}
#map .oltb-chip--gray-light:focus {
  box-shadow: 0 0 0 3px rgba(211, 217, 230, 0.5);
}
#map .oltb-chip--gray-mid {
  background-color: #959dad;
}
#map .oltb-chip--gray-mid:focus {
  box-shadow: 0 0 0 3px rgba(149, 157, 173, 0.5);
}
#map .oltb-chip--gray-dark {
  background-color: #364159;
}
#map .oltb-chip--gray-dark:focus {
  box-shadow: 0 0 0 3px rgba(54, 65, 89, 0.5);
}
#map #oltb {
  position: absolute;
  top: 1rem;
  right: 8px;
  max-height: calc(100% - 2rem);
  display: inline-flex;
  flex-direction: column;
  padding: 0.25rem;
  padding-top: 0;
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 1px 1px 0 rgba(0, 0, 0, 0.2);
  overflow: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  transition: transform 450ms ease-in-out;
  transform: translateX(-100%) translateX(-1.25rem);
  opacity: 0.75;
}
#map #oltb::-webkit-scrollbar {
  display: none;
}
#map #oltb:empty {
  display: none;
}
#map #oltb.init-visible {
  transform: translate(0) !important;
}
#map #oltb.row {
  max-width: calc(100% - 2rem);
  flex-direction: row;
  padding-top: 0.25rem;
  transform: translateY(-100%) translateY(-1.25rem);
}
#map #oltb.row .oltb-tool-button {
  margin: 0 0 0 0.25rem;
}
#map #oltb.row .oltb-tool-button:first-child {
  margin: 0;
}
#map #oltb.dark {
  background-color: #364159;
}
#map #oltb.dark .oltb-tool-button {
  color: #ffffff;
}
#map #oltb.dark .oltb-tool-button:hover, #map #oltb.dark .oltb-tool-button--active {
  background-color: #6397c2;
  color: #ffffff;
}
#map .oltb-tool-button {
  flex-shrink: 0;
  border-radius: 4px;
  margin: 0.25rem 0 0 0;
  color: #364159;
  height: 2.25rem;
  width: 2.25rem;
  padding: 0;
  background-color: transparent;
  transition: background-color 100ms ease-in-out;
  border: none;
  cursor: pointer;
  position: relative;
}
#map .oltb-tool-button:hover, #map .oltb-tool-button--active {
  background-color: #d7e3fa;
  color: #0166a5;
}
#map .oltb-tool-button--hidden {
  display: none;
}
#map .oltb-tool-button__icon {
  display: inline-block;
  vertical-align: middle;
  filter: drop-shadow(1px 1px 0 rgba(0, 0, 0, 0.1));
}
#map body.oltb-using-keyboard #oltb.dark .oltb-tool-button:focus, #map body.oltb-using-keyboard #oltb.dark .oltb-tool-button:active {
  background-color: #6397c2;
  color: #ffffff;
}
#map body.oltb-using-keyboard #oltb .oltb-tool-button:focus, #map body.oltb-using-keyboard #oltb .oltb-tool-button:active {
  background-color: #d7e3fa;
  color: #0166a5;
}
@media only screen and (max-width: 576px) {
  #map #oltb {
    max-width: calc(100% - 2rem);
    flex-direction: row;
    margin-right: 1rem;
    padding-top: 0.25rem;
    top: 3rem;
    right: 0;
  }
  #map .oltb-tool-button {
    margin: 0 0 0 0.25rem;
  }
  #map .oltb-tool-button:first-child {
    margin: 0;
  }
}
#map .oltb-overlay-tooltip {
  display: block;
  background-color: #364159;
  color: #ffffff;
  border-radius: 4px;
  filter: drop-shadow(1px 1px 0 rgba(0, 0, 0, 0.2));
  position: relative;
  font-size: 0.9rem;
}
#map .oltb-overlay-tooltip::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 100%);
  border-top: 0.375rem solid #364159;
  border-right: 0.375rem solid transparent;
  border-left: 0.375rem solid transparent;
}
#map .oltb-overlay-tooltip--hidden {
  display: none;
}
#map .oltb-overlay-tooltip__item {
  display: block;
  text-align: center;
  margin: 0;
  padding: 0.25rem 0.5rem;
}
#map .oltb-overlay-snap {
  display: block;
  position: relative;
}
#map .oltb-overlay-snap__x-line {
  position: absolute;
  top: 50%;
  height: 2px;
  width: 100%;
}
#map .oltb-overlay-snap__y-line {
  position: absolute;
  left: 50%;
  height: 100%;
  width: 2px;
}
#map .oltb-toolbox-list {
  padding: 0;
  margin: 0 0 0 1rem;
  list-style-type: none;
  position: relative;
}
#map .oltb-toolbox-list::before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  top: 0;
  margin-left: -0.75rem;
  border: 1px dashed #d3d9e6;
}
#map .oltb-toolbox-list__header {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: auto;
  max-width: 100px;
}
#map .oltb-toolbox-list__collapse-icon {
  font-size: 12px;
  transition: transform 0.2s ease;
}
#map .oltb-toolbox-list__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}
#map .oltb-toolbox-list__subitem {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
}
#map .oltb-toolbox-list__sublist {
  flex-basis: 100%; /* ul'yi tam genişlikte yaparak alt satıra geçmesini sağlar */
  list-style-type: none;
  margin-left: 15px;
  margin-top: 8px;
  padding-left: 0;
  max-height: 270px;
  overflow: hidden auto;
}
#map .oltb-toolbox-list__dot {
  flex-shrink: 0;
  width: 0.5rem;
  height: 0.5rem;
  margin-right: 0.75rem;
  margin-left: -1.25rem;
  background-color: #d3d9e6;
  border-radius: 4px;
  box-shadow: 0 0 0 3px rgba(211, 217, 230, 0.3);
}
#map .oltb-toolbox-list__item {
  flex-wrap: wrap;
  min-height: 33px;
  padding: 4px;
  margin-bottom: 0.25rem;
  border-radius: 4px;
  color: #364159;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  border: 1px dashed transparent;
}
#map .oltb-toolbox-list__item:last-child {
  margin-bottom: 0;
}
#map .oltb-toolbox-list__item--chosen {
  color: #0166a5;
  border-color: #0166a5;
  background-color: #d7e3fa;
}
#map .oltb-toolbox-list__item--drag {
  color: #364159;
  border-color: #364159;
  background-color: #d3d9e6;
}
#map .oltb-toolbox-list__item--drag .oltb-toolbox-list__handle {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) !important;
}
#map .oltb-toolbox-list__item--ghost {
  color: #0166a5;
  border-color: #0166a5;
  background-color: #d7e3fa;
}
#map .oltb-toolbox-list__item--ghost .oltb-toolbox-list__handle {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) !important;
}
#map .oltb-toolbox-list__item--indicate {
  font-weight: bold;
  color: #0166a5 !important;
  border-color: #0166a5;
  background-color: #d7e3fa;
}
#map .oltb-toolbox-list__item--indicate .oltb-toolbox-list__dot {
  background-color: #3caea3;
  box-shadow: 0 0 0 3px rgba(60, 174, 163, 0.3);
}
#map .oltb-toolbox-list__item--indicate .oltb-toolbox-list__handle {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) !important;
}
#map .oltb-toolbox-list__handle {
  width: 10px;
  height: 24px;
  margin-left: 0.5rem;
  cursor: move;
  background-position: calc(100% + 0.5rem);
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
#map .oltb-toolbox-list__title {
  margin: 0 1rem 0 0;
  cursor: default;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  display: inline-block;
}
#map .oltb-toolbox-list--selectable .oltb-toolbox-list__dot {
  cursor: pointer;
}
#map .oltb-toolbox-list--selectable .oltb-toolbox-list__item--active .oltb-toolbox-list__dot {
  background-color: #3caea3;
  box-shadow: 0 0 0 3px rgba(60, 174, 163, 0.3);
}
#map .oltb-toolbox-list--selectable .oltb-toolbox-list__title {
  cursor: pointer;
}
#map body.oltb-dark .oltb-toolbox-list__item {
  color: #ffffff;
}
#map body.oltb-dark .oltb-toolbox-list__item--chosen {
  color: #0166a5;
}
#map body.oltb-dark .oltb-toolbox-list__item--drag {
  color: #364159;
}
#map body.oltb-dark .oltb-toolbox-list__item--ghost {
  color: #0166a5;
}
#map body.oltb-dark .oltb-toolbox-list__handle {
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
#map .oltb-modal {
  background-color: #ffffff;
  display: inline-block;
  max-width: 1100px;
  min-width: 450px;
  margin: 2rem 1rem;
  padding: 1.5rem;
  border-radius: 4px;
  box-shadow: 1px 1px 0 rgba(0, 0, 0, 0.3);
}
#map .oltb-modal--maximized {
  max-width: 100%;
  width: calc(100% - 2rem);
}
#map .oltb-modal--push-width {
  width: calc(100% - 2rem);
}
#map .oltb-modal-backdrop {
  display: block;
  overflow-y: auto;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 900;
  text-align: center;
}
#map .oltb-modal-backdrop--fixed {
  position: fixed;
}
#map .oltb-modal__header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  margin-bottom: 1rem;
}
#map .oltb-modal__title {
  margin: 0;
  color: #364159;
  text-align: left;
}
#map .oltb-modal__close {
  margin: 0;
  color: #364159;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  width: 1.75rem;
  height: 1.75rem;
}
#map .oltb-modal__buttons-wrapper {
  margin-top: 1.5rem;
}
#map .oltb-modal__content {
  text-align: left;
  color: #364159;
}
#map .oltb-modal__content > :last-child {
  margin-bottom: 0 !important;
}
#map .oltb-modal__content > :first-child {
  margin-top: 0 !important;
}
#map body.oltb-dark .oltb-modal {
  background-color: #364159;
}
#map body.oltb-dark .oltb-modal__close, #map body.oltb-dark .oltb-modal__title, #map body.oltb-dark .oltb-modal__content {
  color: #ffffff;
}
@media only screen and (max-width: 576px) {
  #map .oltb-modal {
    min-width: calc(100% - 2rem);
  }
}
#map .oltb-dialog {
  background-color: #ffffff;
  display: inline-block;
  min-width: 400px;
  max-width: 400px;
  margin: 2rem auto;
  padding: 1.5rem;
  border-radius: 4px;
  box-shadow: 1px 1px 0 rgba(0, 0, 0, 0.3);
  color: #364159;
}
#map .oltb-dialog-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 900;
  text-align: center;
}
#map .oltb-dialog-backdrop--fixed {
  position: fixed;
}
#map .oltb-dialog__title {
  text-align: left;
}
#map .oltb-dialog__message {
  text-align: left;
}
#map .oltb-dialog__buttons-wrapper {
  text-align: right;
  margin-top: 1.5rem;
}
#map .oltb-dialog__btn {
  padding: 0.5rem 0.625rem;
}
#map .oltb-dialog__btn:last-child {
  margin-left: 0.5rem;
}
#map .oltb-dialog__btn:only-child {
  margin: 0;
}
#map body.oltb-dark .oltb-dialog {
  background-color: #364159;
  color: #ffffff;
}
@media only screen and (max-width: 576px) {
  #map .oltb-dialog {
    min-width: calc(100% - 2rem);
    max-width: calc(100% - 2rem);
  }
}
#map .oltb-toast {
  color: #364159;
  background-color: #ffffff;
  cursor: default;
  min-width: 320px;
  padding: 0.75rem 0.875rem;
  border-radius: 4px;
  box-shadow: 1px 1px 0 rgba(0, 0, 0, 0.2);
  margin: 0 1rem 1rem 1rem;
  border-left: 4px solid;
  display: flex;
  align-items: center;
}
#map .oltb-toast-container {
  position: absolute;
  bottom: 0;
  right: 0;
  overflow-x: hidden;
  z-index: 1000;
}
#map .oltb-toast__content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
#map .oltb-toast__title {
  text-shadow: 1px 1px 0 rgba(0, 0, 0, 0.1);
  margin: 0;
}
#map .oltb-toast__message {
  font-size: 1rem;
  margin: 0.5rem 0 0 0;
  text-shadow: 1px 1px 0 rgba(0, 0, 0, 0.1);
}
#map .oltb-toast__message:empty {
  display: none;
}
#map .oltb-toast--clickable {
  cursor: pointer;
}
#map .oltb-toast--remove {
  margin-right: 0;
}
#map .oltb-toast--info {
  border-left-color: #6397c2;
}
#map .oltb-toast--warning {
  border-left-color: #fcbe80;
}
#map .oltb-toast--error {
  border-left-color: #e96b69;
}
#map .oltb-toast--success {
  border-left-color: #3caea3;
}
#map body.oltb-dark .oltb-toast {
  color: #ffffff;
  background-color: #364159;
}
#map .oltb-toolbox-container {
  min-width: 320px;
  max-width: 410px;
  position: absolute;
  pointer-events: auto;
  z-index: 800;
  top: 6rem;
  right: 3.75rem;
  max-height: calc(100% - 2rem);
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 1px 1px 0 rgba(0, 0, 0, 0.2);
  padding: 0 1rem;
  transition: transform 450ms ease-in-out;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  opacity: 0.85;
}
#map .oltb-toolbox-container::-webkit-scrollbar {
  display: none;
}
#map .oltb-toolbox-container--collision {
  top: 4.5rem;
  max-height: calc(100% - 5.5rem);
}
#map .oltb-toolbox-container--hidden {
  transform: translateX(100%) translateX(1rem);
}
#map .oltb-font-weight-normal {
  font-weight: normal !important;
}
#map body.oltb-dark .oltb-toolbox-container {
  background-color: #364159;
}
@media only screen and (max-width: 576px) {
  #map .oltb-toolbox-container {
    width: calc(100% - 2rem);
    top: 4.5rem;
    max-height: calc(100% - 5.5rem);
  }
}
#map .oltb-toolbox-section {
  margin: 1rem 0;
  display: none;
}
#map .oltb-toolbox-section--show {
  display: block;
}
#map .oltb-toolbox-section__header:not(:first-child) {
  margin-top: 1rem;
}
#map .oltb-toolbox-section__header {
  margin: 0 0 0.625rem 0;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
#map .oltb-toolbox-section__title {
  color: #364159;
  margin: 0;
}
#map .oltb-toolbox-section__icon {
  margin: 0;
  height: 16px;
  width: 16px;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
#map .oltb-toolbox-section__group {
  margin-top: 1rem;
}
#map .oltb-toolbox-section__group:first-child {
  margin-top: 0;
}
#map .oltb-toolbox-section__group li:first-child:not(.oltb-toolbox-list__subitem) {
  margin-top: 1rem;
}
#map .oltb-toolbox-section__group .oltb-label {
  font-size: 1rem;
}
#map .oltb-toolbox-section__group--split-group {
  display: flex;
  align-items: end;
  flex-direction: row;
  gap: 0.5rem;
}
#map .oltb-toolbox-section__group--split-group .oltb-select,
#map .oltb-toolbox-section__group--split-group .oltb-input {
  min-width: 100px;
}
#map .oltb-toolbox-section__group--topmost li:first-child {
  margin-top: 0;
}
#map .oltb-toolbox-section__group--sub-toolbar {
  display: block;
  font-size: 0;
}
#map .oltb-toolbox-section__group--sub-toolbar .oltb-btn {
  margin-left: 0.375rem;
}
#map .oltb-toolbox-section__group--sub-toolbar .oltb-btn:first-of-type {
  margin-left: 0;
}
#map .oltb-toolbox-section__group-part {
  flex: 1 1;
}
#map body.oltb-dark .oltb-toolbox-section__title {
  color: #ffffff;
}
#map body.oltb-dark .oltb-toolbox-section__icon {
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
#map .oltb-info-window {
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: scale(1) translateX(-50%);
  min-width: 360px;
  padding: 1.5rem;
  background-color: #ffffff;
  color: #ffffff;
  border-radius: 4px;
  filter: drop-shadow(0 0 0.25rem rgba(0, 0, 0, 0.4));
  -webkit-user-select: none;
          user-select: none;
}
#map .oltb-info-window::after {
  content: "";
  position: absolute;
  bottom: 1px;
  left: 50%;
  transform: translate(-50%, 100%);
  border-top: 0.625rem solid #ffffff;
  border-left: 0.625rem solid transparent;
  border-right: 0.625rem solid transparent;
}
#map .oltb-info-window__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 1rem 0;
}
#map .oltb-info-window__title {
  color: #364159;
  margin: 0;
}
#map .oltb-info-window__close {
  color: #364159;
}
#map .oltb-info-window__content {
  color: #364159;
}
#map .oltb-info-window__content p {
  font-size: 1rem;
}
#map .oltb-info-window__content img {
  width: 350px;
  border-radius: 4px;
  box-shadow: 1px 1px 0 rgba(0, 0, 0, 0.2);
}
#map .oltb-info-window__coordinates {
  margin: 0;
  font-size: 0.8rem;
  white-space: nowrap;
  font-weight: bold;
}
#map .oltb-info-window__buttons-wrapper {
  margin-left: 1rem;
  flex-shrink: 0;
}
#map .oltb-info-window__footer {
  color: #364159;
  margin: 1.25rem -0.25rem -0.25rem -0.25rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow-x: scroll;
  padding: 0.25rem;
  font-size: 0;
}
#map body.oltb-dark .oltb-info-window {
  background-color: #364159;
}
#map body.oltb-dark .oltb-info-window::after {
  border-top: 0.625rem solid #364159;
}
#map body.oltb-dark .oltb-info-window__title, #map body.oltb-dark .oltb-info-window__close, #map body.oltb-dark .oltb-info-window__content, #map body.oltb-dark .oltb-info-window__footer {
  color: #ffffff;
}
@media only screen and (max-width: 576px) {
  #map .oltb-info-window {
    min-width: 330px;
  }
}
#map .oltb-context-menu {
  display: none;
  list-style: none;
  margin: 0;
  max-width: 250px;
  min-width: 230px;
  padding: 0;
  position: fixed;
  -webkit-user-select: none;
          user-select: none;
  background-color: #ffffff;
  box-shadow: 1px 1px 0 rgba(0, 0, 0, 0.2);
  text-shadow: 1px 1px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  font-size: 0.875rem;
}
#map .oltb-context-menu__item {
  padding: 0.625rem;
  cursor: pointer;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #364159;
  display: flex;
  align-items: center;
  margin: 0.25rem;
  border-radius: 4px;
  transition: background-color 100ms ease-in-out;
}
#map .oltb-context-menu__item:hover, #map .oltb-context-menu__item:focus {
  background-color: #d7e3fa;
  color: #0166a5;
}
#map .oltb-context-menu__icon {
  pointer-events: none;
  display: flex;
  padding-right: 0.625rem;
  margin: 0;
  filter: drop-shadow(1px 1px 0 rgba(0, 0, 0, 0.1));
}
#map .oltb-context-menu__icon svg {
  width: 20px;
  height: 20px;
}
#map .oltb-context-menu__text {
  margin: 0;
}
#map .oltb-context-menu__divider {
  background-color: rgba(0, 0, 0, 0.15);
  height: 1px;
  margin: 0.25rem 0;
}
#map .oltb-context-menu--show {
  display: block;
}
#map body.oltb-dark .oltb-context-menu {
  background-color: #364159;
}
#map body.oltb-dark .oltb-context-menu__item {
  color: #ffffff;
}
#map body.oltb-dark .oltb-context-menu__item:hover, #map body.oltb-dark .oltb-context-menu__item:focus {
  background-color: #6397c2;
  color: #ffffff;
}
#map .tippy-box[data-theme~=oltb] {
  background-color: #364159;
  color: #ffffff;
  box-shadow: 1px 1px 0 rgba(0, 0, 0, 0.1);
  text-shadow: 1px 1px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}
#map .tippy-box[data-theme~=oltb] .tippy-content {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}
#map .tippy-box[data-theme~=oltb][data-placement^=top] > .tippy-arrow::before {
  border-top-color: #364159;
  filter: drop-shadow(1px 1px 0 rgba(0, 0, 0, 0.2));
}
#map .tippy-box[data-theme~=oltb][data-placement^=bottom] > .tippy-arrow::before {
  border-bottom-color: #364159;
  filter: drop-shadow(1px 0 0 rgba(0, 0, 0, 0.1));
}
#map .tippy-box[data-theme~=oltb][data-placement^=left] > .tippy-arrow::before {
  border-left-color: #364159;
  filter: drop-shadow(1px 1px 0 rgba(0, 0, 0, 0.2));
}
#map .tippy-box[data-theme~=oltb][data-placement^=right] > .tippy-arrow::before {
  border-right-color: #364159;
  filter: drop-shadow(0 1px 0 rgba(0, 0, 0, 0.1));
}
#map body.oltb-dark .tippy-color-picker {
  border-radius: 4px;
  border: 1px solid #2f3642;
}
#map body.oltb-dark .tippy-box[data-theme~=oltb-themed] {
  background-color: #ffffff;
  color: #364159;
}
#map body.oltb-dark .tippy-box[data-theme~=oltb-themed].tippy-box[data-theme~=oltb][data-placement^=top] > .tippy-arrow::before {
  border-top-color: #ffffff;
}
#map body.oltb-dark .tippy-box[data-theme~=oltb-themed].tippy-box[data-theme~=oltb][data-placement^=bottom] > .tippy-arrow::before {
  border-bottom-color: #ffffff;
}
#map body.oltb-dark .tippy-box[data-theme~=oltb-themed].tippy-box[data-theme~=oltb][data-placement^=left] > .tippy-arrow::before {
  border-left-color: #ffffff;
}
#map body.oltb-dark .tippy-box[data-theme~=oltb-themed].tippy-box[data-theme~=oltb][data-placement^=right] > .tippy-arrow::before {
  border-right-color: #ffffff;
}
#map body:not(.oltb-dark) .tippy-color-picker {
  border-radius: 4px;
  border: 1px solid #ced4da;
}
#map body:not(.oltb-dark) .tippy-box[data-theme~=oltb-inverted-themed] {
  background-color: #ffffff;
  color: #364159;
}
#map body:not(.oltb-dark) .tippy-box[data-theme~=oltb-inverted-themed].tippy-box[data-theme~=oltb][data-placement^=top] > .tippy-arrow::before {
  border-top-color: #ffffff;
}
#map body:not(.oltb-dark) .tippy-box[data-theme~=oltb-inverted-themed].tippy-box[data-theme~=oltb][data-placement^=bottom] > .tippy-arrow::before {
  border-bottom-color: #ffffff;
}
#map body:not(.oltb-dark) .tippy-box[data-theme~=oltb-inverted-themed].tippy-box[data-theme~=oltb][data-placement^=left] > .tippy-arrow::before {
  border-left-color: #ffffff;
}
#map body:not(.oltb-dark) .tippy-box[data-theme~=oltb-inverted-themed].tippy-box[data-theme~=oltb][data-placement^=right] > .tippy-arrow::before {
  border-right-color: #ffffff;
}
#map .oltb-spinner {
  border-color: rgba(1, 102, 165, 0.3);
  border-top-color: rgb(1, 102, 165);
  border-style: solid;
  border-width: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}
#map .oltb-spinner--small {
  border-width: 3px;
  width: 25px;
  height: 25px;
}
#map .oltb-spinner--medium {
  border-width: 8px;
  width: 50px;
  height: 50px;
}
#map .oltb-spinner--large {
  border-width: 10px;
  width: 100px;
  height: 100px;
}
#map body.oltb-dark .oltb-spinner {
  border-color: rgba(255, 255, 255, 0.3);
  border-top-color: rgb(255, 255, 255);
}
#map .oltb-func-btn {
  display: inline-flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  font-weight: 400;
  text-align: center;
  box-shadow: 1px 1px 0 rgba(0, 0, 0, 0.2);
  border: none;
  border-radius: 50%;
  width: 1.875rem;
  height: 1.875rem;
  background-color: #6397c2;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 16px 16px;
  transition: background-color 100ms ease-in-out;
  margin-left: 5px;
}
#map .oltb-func-btn:focus {
  box-shadow: 0 0 0 3px rgba(99, 151, 194, 0.5);
}
#map .oltb-func-btn:first-child {
  margin-left: 0;
}
#map .oltb-func-btn:hover, #map .oltb-func-btn:focus {
  background-color: #0166a5;
}
#map .oltb-func-btn--crosshair {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
#map .oltb-func-btn--delete {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
#map .oltb-func-btn--edit {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}
#map .oltb-func-btn--download {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
#map .oltb-func-btn--layer {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}
#map .oltb-func-btn--geo-pin {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}
#map .oltb-func-btn--copy {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}
#map .oltb-color-input {
  display: block;
  width: 100%;
  padding: 0.438rem;
  color: #191e29;
  background-color: #f3f4f5;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  appearance: none;
  border-radius: 4px;
  transition: border-color 150ms ease-in-out, box-shadow 150ms ease-in-out;
  outline: none;
}
#map .oltb-color-input:focus {
  border: 1px solid rgba(99, 151, 194, 0.5);
  box-shadow: 0 0 0 3px rgba(99, 151, 194, 0.3);
}
#map .oltb-color-input__inner {
  padding: 0.5rem;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}
#map body.oltb-dark .oltb-color-input {
  background-color: #959dad;
  border: 1px solid #2f3642;
}
#map body.oltb-dark .oltb-color-input:focus {
  box-shadow: 0 0 0 3px rgba(149, 157, 173, 0.5);
}
#map .oltb-debug {
  border-bottom: 1px dashed #959dad;
  padding: 0.5rem 0;
}
#map .oltb-debug__commands {
  padding-bottom: 1rem;
  border-bottom: 1px dashed #959dad;
}
#map .oltb-debug__header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  cursor: pointer;
}
#map .oltb-debug__title {
  margin: 0;
  padding: 0.25rem 0;
}
#map .oltb-debug__toggle {
  color: #364159;
}
#map .oltb-debug__json {
  padding: 0.5rem;
  border-radius: 4px;
  background-color: #f3f4f5;
  border: 1px solid #d3d9e6;
  overflow: auto;
  max-height: 600px;
  font-size: 1rem;
}
#map body.oltb-dark .oltb-debug__toggle {
  color: #ffffff;
}
#map body.oltb-dark .oltb-debug__json {
  color: #364159;
}
#map .oltb-log {
  margin: 1rem 0;
  padding: 0 1rem 0 0;
  overflow-y: scroll;
  max-height: 600px;
}
#map .oltb-log:empty, #map .oltb-log--empty {
  display: none;
}
#map .oltb-log__filter {
  display: flex;
  gap: 0.5rem;
  overflow: scroll;
}
#map .oltb-log__item {
  padding: 0.5rem;
  border-radius: 4px;
  margin: 0.5rem 0;
}
#map .oltb-log__item:first-child {
  margin-top: 0;
}
#map .oltb-log__item:last-child {
  margin-bottom: 0;
}
#map .oltb-log__item--hidden {
  display: none;
}
#map .oltb-log__header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  cursor: default;
}
#map .oltb-log__header--toggleable {
  cursor: pointer;
}
#map .oltb-log__timestamp {
  font-weight: bold;
  margin: 0;
  white-space: nowrap;
}
#map .oltb-log__level-icon {
  margin: 0 0.5rem 0 0;
}
#map .oltb-log__title {
  margin: 0;
}
#map .oltb-log__toggle {
  color: inherit;
}
#map .oltb-log__json {
  padding: 1rem 0 0 0;
  margin: 0;
  border-radius: 4px;
  background-color: transparent;
  overflow: auto;
  max-height: 300px;
  font-size: 1rem;
}
#map .oltb-table {
  border-collapse: collapse;
  width: 100%;
  color: #364159;
  cursor: default;
}
#map .oltb-table th {
  text-align: left;
  background-color: #f3f4f5;
}
#map .oltb-table--vertical th,
#map .oltb-table--vertical td {
  padding: 0.5rem;
  border: 1px dashed #959dad;
}
#map .oltb-table--vertical td {
  width: 100%;
}
#map .oltb-table--horizontal th {
  padding-top: 0.5rem;
}
#map .oltb-table--horizontal td {
  padding: 0.25rem 0 0.5rem 0;
}
#map .oltb-table--horizontal tr:not(:last-child):nth-child(2n) > td {
  border-bottom: 1px dashed #959dad;
}
#map .oltb-table--no-background th {
  background-color: transparent;
}
#map .oltb-table--tight-bottom-and-top tr:first-child th {
  padding-top: 0;
}
#map .oltb-table--tight-bottom-and-top tr:last-child td {
  padding-bottom: 0;
}
#map body.oltb-dark .oltb-table {
  color: #ffffff;
}
#map body.oltb-dark .oltb-table th {
  background-color: rgba(0, 0, 0, 0.2);
}
#map body .ol-scale-line {
  border-radius: 4px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #ffffff;
  padding: 0.5rem;
  box-shadow: 1px 1px 0 rgba(0, 0, 0, 0.2);
}
#map body .ol-scale-line-inner {
  border-width: 2px;
  padding-bottom: 4px;
  border-color: #364159;
  color: #364159;
}
#map body.oltb-dark .ol-scale-line {
  background-color: #364159;
}
#map body.oltb-dark .ol-scale-line-inner {
  border-color: #ffffff;
  color: #ffffff;
}
#map body #map .ol-attribution {
  padding: 0.25rem;
  background-color: #ffffff;
  bottom: 1rem;
  right: 1rem;
  border-radius: 4px;
  box-shadow: 1px 1px 0 rgba(0, 0, 0, 0.2);
}
#map body #map .ol-attribution ul,
#map body #map .ol-attribution a {
  color: #364159;
  text-shadow: none;
}
#map body #map .ol-attribution-expand, #map body #map .ol-attribution-collapse {
  margin: 0;
  display: block;
}
#map body #map .ol-attribution-collapse {
  height: 10px;
}
#map body #map .ol-attribution button {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: normal;
  cursor: pointer;
  background-color: #ffffff;
  color: #364159;
}
#map body #map .ol-attribution button:hover, #map body #map .ol-attribution button:focus {
  background-color: #d7e3fa;
  outline: none;
}
#map body.oltb-dark #map .ol-attribution {
  background-color: #364159;
  font-weight: normal;
}
#map body.oltb-dark #map .ol-attribution ul,
#map body.oltb-dark #map .ol-attribution a {
  color: #ffffff;
}
#map body.oltb-dark #map .ol-attribution button {
  background-color: #364159;
  color: #ffffff;
}
#map body.oltb-dark #map .ol-attribution button:hover, #map body.oltb-dark #map .ol-attribution button:focus {
  background-color: #6397c2;
}
#map #oltb-overview-toolbox .ol-overviewmap {
  position: relative;
  padding: 0;
  border-radius: 4px;
}
#map #oltb-overview-toolbox .ol-overviewmap .ol-overviewmap-map {
  display: block;
  width: 100%;
  margin: 0;
  border-radius: 4px;
}
#map #oltb-overview-toolbox .ol-overviewmap .ol-overviewmap-box {
  border: 2px dotted #364159;
}
#map #oltb-overview-toolbox .ol-overviewmap .ol-viewport {
  border-radius: 4px;
}
#map body .ol-dragzoom {
  border-width: 2px;
  border-style: dashed;
  border-color: #0166a5;
  background-color: rgba(215, 227, 250, 0.5);
}
#map .oltb-acp {
  display: block;
}
#map .oltb-acp__header {
  cursor: pointer;
  margin-top: 0.313rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
#map .oltb-acp__title {
  pointer-events: none;
}
#map .oltb-acp__icon {
  cursor: pointer;
  margin: 0;
  height: 16px;
  width: 16px;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
#map body.oltb-dark .oltb-acp__icon {
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
#map .oltb-feature-opacity {
  width: 90px;
  margin-left: 8px;
  vertical-align: middle;
}
#map .oltb-feature-opacity__pct {
  margin-left: 8px;
  min-width: 38px;
  display: inline-block;
  text-align: right;
  opacity: 0.8;
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/lib/oltb/scss/oltb.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EA+OE,yCAAA;EAMA,mBAAA;EAMA,4CAAA;EA0MQ,6JAAA;AA/bV;AAyGE;EACE,yBAAA;EACA,iCAAA;EACA,kBAAA;EACA,4BAAA;EACA,2BAAA;EACA,6BAAA;EACA,6BAAA;AAvGJ;AAyGI;EACE,4BAAA;EACA,0BAAA;EACA,mCAAA;AAvGN;AA0GI;EACE,4BAAA;EACA,0BAAA;EACA,mCAAA;AAxGN;AA2GI;EACE,6BAAA;AAzGN;AA4GI;EACE,8BAAA;AA1GN;AA6GI;EACE,2BAAA;AA3GN;AA8GI;EACE,oCAAA;AA5GN;AAgHE;EACE;IACE,uBAAA;EA9GJ;EAiHE;IACE,yBAAA;EA/GJ;AACF;AAkHE;EACE;IACE,2BAAA;EAhHJ;EAmHE;IACE,wBAAA;EAjHJ;AACF;AAoHE;EACE;IACE,wBAAA;EAlHJ;EAqHE;IACE,2BAAA;EAnHJ;AACF;AAsHE;EACE;IACE,sBAAA;EApHJ;EAuHE;IACE,sBAAA;EArHJ;EAwHE;IACE,mBAAA;EAtHJ;AACF;AAyHE;EACE;IACE,yCAAA;EAvHJ;EA0HE;IACE,yCAAA;EAxHJ;EA2HE;IACE,oCAAA;EAzHJ;AACF;AA4HE;;;EAKE,sBAAA;EAEA,aAAA;AA3HJ;AA4IE;EACE,mBAAA;AA1IJ;AA6IE;EACE,YAAA;AA3IJ;AA+IE;EACE,cAxLe;EAyLf,UAAA;AA7IJ;AAiJE;EACE,cA9Le;EA+Lf,UAAA;AA/IJ;AAmJE;;;EAGE,wCAAA;AAjJJ;AAmJI;;;EACE,wCAAA;EAEA,0BAAA;EACA,aAAA;AA/IN;AAqJI;EACE,oBAAA;AAnJN;AAuJI;EACE,8BAAA;AArJN;AAwJI;EACE,+BAAA;AAtJN;AAyJI;EACE,6BAAA;AAvJN;AA0JI;EACE,+BAAA;AAxJN;AA2JI;EACE,2BAAA;AAzJN;AA4JI;EACE,6BAAA;AA1JN;AA8JI;EACE,iCAAA;AA5JN;AA+JI;EACE,kCAAA;AA7JN;AAgKI;EACE,gCAAA;AA9JN;AAiKI;EACE,kCAAA;AA/JN;AAkKI;EACE,8BAAA;AAhKN;AAmKI;EACE,gCAAA;AAjKN;AAqKI;EACE,+BAAA;AAnKN;AAsKI;EACE,gCAAA;AApKN;AAuKI;EACE,8BAAA;AArKN;AAwKI;EACE,gCAAA;AAtKN;AAyKI;EACE,4BAAA;AAvKN;AA0KI;EACE,8BAAA;AAxKN;AA4KI;EACE,gCAAA;AA1KN;AA6KI;EACE,iCAAA;AA3KN;AA8KI;EACE,+BAAA;AA5KN;AA+KI;EACE,iCAAA;AA7KN;AAgLI;EACE,6BAAA;AA9KN;AAiLI;EACE,+BAAA;AA/KN;AAmLI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAjLN;AAmLM;EACE,SAAA;AAjLR;AAqLI;EACE,sBAAA;AAnLN;AAsLI;EACE,wBAAA;AApLN;AAuLI;EACE,wBAAA;AArLN;AAwLI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAtLN;AAyLI;EACE,kBAAA;AAvLN;AA0LI;EACE,8BAAA;AAxLN;AA2LI;EACE,uBAAA;AAzLN;AA4LI;EACE,wBAAA;EACA,qBAAA;AA1LN;AA4LM;EACE,aAAA;AA1LR;AA8LI;EACE,wBAAA;EACA,qBAAA;EACA,gCAAA;AA5LN;AA8LM;EACE,aAAA;EACA,cAAA;EACA,mBA/VkB;EAgWlB,4BAAA;EACA,+BAAA;AA5LR;AA+LM;EACE,yBApWkB;EAqWlB,qBAAA;AA7LR;AA+LQ;EACE,yBAxWgB;AA2K1B;AAkMI;EACE,cA9XS;AA8Lf;AAkMM;EACE,0BAAA;AAhMR;AAuME;;EAEE,SAAA;EACA,YAAA;EACA,iCAAA;AArMJ;AAwME;EACE,WAAA;EACA,YAAA;EACA,yBA9XmB;EA+XnB,kBAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;AAtMJ;AAyME;EACE,cAAA;EACA,cAhae;EAiaf,sBAAA;AAvMJ;AAyMI;EACE,eAAA;AAvMN;AA0MI;EACE,eAAA;AAxMN;AA2MI;EACE,qBAAA;AAzMN;AA6ME;EACE,cApZY;AAyMhB;AA8ME;EACE,wBAAA;AA5MJ;AA+ME;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cA/be;EAgcf,yDAAA;EACA,4BAAA;EACA,yCAAA;EACA,0BAAA;EACA,yBAxce;EAycf,yBAAA;EACA,kBA5bc;EA+bd,gBAAA;EACA,iBAAA;EACA,aAAA;AA7MJ;AA+MI;EACE,yCAAA;EACA,6CAAA;AA7MN;AAgNI;EACE,0CAjb8B;EAkb9B,mBAAA;AA9MN;AAkNE;EACE,yBA3de;EA4df,yBAAA;AAhNJ;AAkNI;EACE,8CAAA;AAhNN;AAmNI;EACE,0CA9b6B;AA6OnC;AAqNE;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cA7ee;EA8ef,4BAAA;EACA,yBAnfe;EAoff,yBAAA;EAGA,gBAAA;EACA,kBA1ec;EA2ed,wEAAA;EACA,aAAA;AAnNJ;AAqNI;EACE,yCAAA;EACA,6CAAA;AAnNN;AAsNI;EACE,0CA5d8B;EA6d9B,mBAAA;AApNN;AAwNE;EACE,aAAA;EACA,6BAAA;AAtNJ;AAwNI;EACE,oBAAA;AAtNN;AA0NE;EACE,yBA/gBe;EAghBf,yBAAA;AAxNJ;AA0NI;EACE,8CAAA;AAxNN;AA2NI;EACE,0CAlf6B;AAyRnC;AA6NE;EACE,oBAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,wCAxfe;EAyff,yCAlfkB;EAmflB,YAAA;EACA,kBA3hBc;EA4hBd,eAAA;EACA,eAAA;EACA,cA5gBY;EA6gBZ,6BAAA;AA3NJ;AA6NI;EACE,YAAA;EACA,mBAAA;AA3NN;AA8NI;EACE,iDApgBuB;AAwS7B;AA+NI;EACE,kBAAA;AA7NN;AAgOI;EACE,gBAAA;EACA,UAAA;AA9NN;AAiOI;EACE,yBAnnBa;AAoZnB;AAiOM;EACE,8CAAA;AA/NR;AAmOI;EACE,yBA1nBa;AAyZnB;AAmOM;EACE,6CAAA;AAjOR;AAqOI;EACE,yBAjoBa;AA8ZnB;AAqOM;EACE,4CAAA;AAnOR;AAuOI;EACE,yBAlnBc;AA6YpB;AAuOM;EACE,8CAAA;AArOR;AAyOI;EACE,yBAznBc;AAkZpB;AAyOM;EACE,6CAAA;AAvOR;AA2OI;EACE,yBAhoBc;AAuZpB;AA2OM;EACE,4CAAA;AAzOR;AA6OI;EACE,yBAtnBY;AA2YlB;AA6OM;EACE,8CAAA;AA3OR;AA+OI;EACE,yBA7nBY;AAgZlB;AA+OM;EACE,8CAAA;AA7OR;AAiPI;EACE,yBApoBY;AAqZlB;AAiPM;EACE,4CAAA;AA/OR;AAmPI;EACE,yBAzoBa;AAwZnB;AAmPM;EACE,8CAAA;AAjPR;AAqPI;EACE,yBAhpBa;AA6ZnB;AAqPM;EACE,8CAAA;AAnPR;AAuPI;EACE,yBAvpBa;AAkanB;AAuPM;EACE,2CAAA;AArPR;AA0PE;EACE,8CAAA;AAxPJ;AA2PE;EACE,aAAA;EACA,mBAAA;AAzPJ;AA2PI;EACE,mBAAA;AAzPN;AA4PI;EACE,gBAAA;AA1PN;AA6PI;EACE,kCAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,yBAppBqB;EAqpBrB,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,yBAAA;EAGA,gBAAA;EACA,iCAAA;EACA,yBAAA;EACA,kBAnrBY;EAorBZ,wEAAA;AA3PN;AA6PM;EACE,yBArvBW;EAsvBX,qBAtvBW;AA2fnB;AA8PM;EACE,4BAAA;EACA,yDAAA;AA5PR;AA+PM;EACE,yBAAA;EACA,6CAAA;AA7PR;AAmQI;EACE,cAvrBU;AAsbhB;AAoQI;EACE,yBAztBa;EA0tBb,YAAA;AAlQN;AAoQM;EACE,yBA/wBW;AA6gBnB;AAqQM;EACE,YAAA;EACA,8CAAA;AAnQR;AAwQE;EACE,gBAAA;EACA,wBAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;AAtQJ;AAwQI;EACE,cAAA;AAtQN;AA2QI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAjzBa;EAkzBb,YAAA;EACA,8CAAA;EACA,iDAltBqB;EAmtBrB,YAAA;EACA,4BAAA;EACA,kCAAA;EACA,0BAAA;EACA,yDAAA;EACA,wBAAA;AAzQN;AA4QI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAj0Ba;EAk0Bb,YAAA;EACA,8CAAA;EACA,iDAluBqB;EAmuBrB,YAAA;EACA,4BAAA;EACA,kCAAA;EACA,0BAAA;EACA,yDAAA;AA1QN;AA8QE;EACE,oBAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAjvBkB;EAkvBlB,YAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,cA3wBY;EA4wBZ,6BAAA;EACA,gBAAA;AA5QJ;AA8QI;EACE,oBAAA;AA5QN;AA+QI;EACE,6BAAA;EACA,kBAAA;AA7QN;AAgRI;EACE,yBA12Ba;AA4lBnB;AAgRM;EACE,8CAAA;AA9QR;AAkRI;EACE,yBAj3Ba;AAimBnB;AAkRM;EACE,6CAAA;AAhRR;AAoRI;EACE,yBAx3Ba;AAsmBnB;AAoRM;EACE,4CAAA;AAlRR;AAsRI;EACE,yBAz2Bc;AAqlBpB;AAsRM;EACE,8CAAA;AApRR;AAwRI;EACE,yBAh3Bc;AA0lBpB;AAwRM;EACE,6CAAA;AAtRR;AA0RI;EACE,yBAv3Bc;AA+lBpB;AA0RM;EACE,4CAAA;AAxRR;AA4RI;EACE,yBA72BY;AAmlBlB;AA4RM;EACE,8CAAA;AA1RR;AA8RI;EACE,yBAp3BY;AAwlBlB;AA8RM;EACE,8CAAA;AA5RR;AAgSI;EACE,yBA33BY;AA6lBlB;AAgSM;EACE,4CAAA;AA9RR;AAkSI;EACE,yBAh4Ba;AAgmBnB;AAkSM;EACE,8CAAA;AAhSR;AAoSI;EACE,yBAv4Ba;AAqmBnB;AAoSM;EACE,8CAAA;AAlSR;AAsSI;EACE,yBA94Ba;AA0mBnB;AAsSM;EACE,2CAAA;AApSR;AAySE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,6BAAA;EACA,oBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBA/3BuB;EAg4BvB,kBAr5Bc;EAs5Bd,wCAt3Be;EAu3Bf,gBAAA;EACA,wBAAA;EACA,qBAAA;EACA,uCAAA;EACA,iDAAA;EACA,aAAA;AAvSJ;AAySI;EACE,aAAA;AAvSN;AA0SI;EACE,aAAA;AAxSN;AA2SI;EACE,kCAAA;AAzSN;AA4SI;EACE,4BAAA;EACA,mBAAA;EACA,oBAAA;EACA,iDAAA;AA1SN;AA4SM;EACE,qBAAA;AA1SR;AA4SQ;EACE,SAAA;AA1SV;AA+SI;EACE,yBAr8Ba;AAwpBnB;AA+SM;EACE,cA36BQ;AA8nBhB;AA+SQ;EAEE,yBA//BS;EAggCT,cAh7BM;AAkoBhB;AAoTE;EACE,cAAA;EACA,kBA18Bc;EA28Bd,qBAAA;EACA,cAv9Be;EAw9Bf,eAAA;EACA,cAAA;EACA,UAAA;EACA,6BAAA;EACA,8CAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AAlTJ;AAoTI;EAEE,yBAvhCa;EAwhCb,cAthCa;AAmuBnB;AAsTI;EACE,aAAA;AApTN;AAuTI;EACE,qBAAA;EACA,sBAAA;EACA,iDAh8BuB;AA2oB7B;AA+TQ;EAEE,yBA7iCS;EA8iCT,cA99BM;AAgqBhB;AAoUM;EAEE,yBAvjCW;EAwjCX,cAtjCW;AAmvBnB;AA0UE;EACE;IACE,4BAAA;IACA,mBAAA;IACA,kBAAA;IACA,oBAAA;IACA,SAAA;IACA,QAAA;EAxUJ;EA2UE;IACE,qBAAA;EAzUJ;EA2UI;IACE,SAAA;EAzUN;AACF;AA6UE;EACE,cAAA;EACA,yBAhiCe;EAiiCf,cApgCY;EAqgCZ,kBAvhCc;EAyhCd,iDAAA;EACA,kBAAA;EACA,iBAAA;AA3UJ;AA6UI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,gCAAA;EACA,kCAAA;EACA,wCAAA;EACA,uCAAA;AA3UN;AA8UI;EACE,aAAA;AA5UN;AA+UI;EACE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,uBAAA;AA7UN;AAiVE;EACE,cAAA;EACA,kBAAA;AA/UJ;AAiVI;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;AA/UN;AAkVI;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;AAhVN;AAwVE;EACE,UAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;AAtVJ;AAwVI;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,MAAA;EACA,qBAAA;EACA,0BAAA;AAtVN;AAyVI;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EAEA,gBAAA;AAxVN;AA2VI;EACE,eAAA;EACA,+BAAA;AAzVN;AA4VI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AA1VN;AA6VI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AA3VN;AA8VI;EACE,gBAAA,EAAA,6DAAA;EAIA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;AA/VN;AAkWI;EACE,cAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAvpCa;EAwpCb,kBA3oCY;EA4oCZ,8CAAA;AAhWN;AAmWI;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAppCY;EAqpCZ,cAhqCa;EAiqCb,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,8BAAA;AAjWN;AAmWM;EACE,gBAAA;AAjWR;AAsWM;EACE,cAjuCW;EAkuCX,qBAluCW;EAmuCX,yBAruCW;AAi4BnB;AAyWM;EACE,cAvrCW;EAwrCX,qBAxrCW;EAyrCX,yBA3rCW;AAo1BnB;AAyWQ;EACE,oEAAA;AAvWV;AA6WM;EACE,cArvCW;EAsvCX,qBAtvCW;EAuvCX,yBAzvCW;AA84BnB;AA6WQ;EACE,oEAAA;AA3WV;AA+WM;EACE,iBAAA;EACA,yBAAA;EACA,qBAjwCW;EAkwCX,yBApwCW;AAu5BnB;AA+WQ;EACE,yBA7uCU;EA8uCV,6CAAA;AA7WV;AAgXQ;EACE,oEAAA;AA9WV;AAmXI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,wCAAA;EACA,4BAAA;EACA,yDAAA;AAjXN;AAoXI;EACE,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,qBAAA;AAlXN;AAyXI;EACE,eAAA;AAvXN;AA6XM;EACE,yBAvxCY;EAwxCZ,6CAAA;AA3XR;AA+XI;EACE,eAAA;AA7XN;AAkYI;EACE,cA5uCU;AA42BhB;AAkYM;EACE,cA9zCW;AA87BnB;AAmYM;EACE,cAhxCW;AA+4BnB;AAoYM;EACE,cAt0CW;AAo8BnB;AAsYI;EACE,4BAAA;EACA,yDAAA;AApYN;AAuYE;EACE,yBA9vCuB;EA+vCvB,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eA3xCkB;EA4xClB,kBAzxCc;EA0xCd,wCAzvCgB;AAo3BpB;AAuYI;EACE,eAAA;EACA,wBAAA;AArYN;AAwYI;EACE,wBAAA;AAtYN;AAyYI;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,YAAA;EACA,kBAAA;AAvYN;AAyYM;EACE,eAAA;AAvYR;AA2YI;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,mBAAA;AAzYN;AA4YI;EACE,SAAA;EACA,cA10Ca;EA20Cb,gBAAA;AA1YN;AA6YI;EACE,SAAA;EACA,cAh1Ca;EAi1Cb,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAz0CY;EA00CZ,cAAA;EACA,eAAA;AA3YN;AA8YI;EACE,kBAAA;AA5YN;AA+YI;EACE,gBAAA;EACA,cA/1Ca;AAk9BnB;AA+YM;EACE,2BAAA;AA7YR;AAgZM;EACE,wBAAA;AA9YR;AAmZE;EACE,yBA52Ce;AA29BnB;AAmZI;EAGE,cAp1CU;AAi8BhB;AAuZE;EACE;IACE,4BAAA;EArZJ;AACF;AAuZE;EACE,yBA31CuB;EA41CvB,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAx3CkB;EAy3ClB,kBAt3Cc;EAu3Cd,wCAt1CgB;EAu1ChB,cAn4Ce;AA8+BnB;AAuZI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,YAAA;EACA,kBAAA;AArZN;AAuZM;EACE,eAAA;AArZR;AAyZI;EACE,gBAAA;AAvZN;AA0ZI;EACE,gBAAA;AAxZN;AA2ZI;EACE,iBAAA;EACA,kBAAA;AAzZN;AA4ZI;EACE,wBAAA;AA1ZN;AA4ZM;EACE,mBAAA;AA1ZR;AA6ZM;EACE,SAAA;AA3ZR;AAgaE;EACE,yBA/6Ce;EAg7Cf,cAn5CY;AAq/BhB;AAiaE;EACE;IACE,4BAAA;IACA,4BAAA;EA/ZJ;AACF;AAiaE;EACE,cA17Ce;EA27Cf,yBA35CuB;EA45CvB,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAp7Cc;EAq7Cd,wCAr5Ce;EAs5Cf,wBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;AA/ZJ;AAiaI;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,aAAA;AA/ZN;AAkaI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AAhaN;AAmaI;EACE,yCAn6CgB;EAo6ChB,SAAA;AAjaN;AAoaI;EACE,eAAA;EACA,oBAAA;EACA,yCA16CgB;AAwgCtB;AAoaM;EACE,aAAA;AAlaR;AAsaI;EACE,eAAA;AApaN;AAuaI;EACE,eAAA;AAraN;AAwaI;EACE,0BA/hDa;AAynCnB;AAyaI;EACE,0BA3/Ce;AAolCrB;AA0aI;EACE,0BA1/CY;AAklClB;AA2aI;EACE,0BAlhDc;AAymCpB;AA6aE;EACE,cAh+CY;EAi+CZ,yBA9/Ce;AAmlCnB;AA6aE;EAGE,gBAAA;EACA,gBAAA;EAEA,kBAAA;EACA,oBAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;EACA,6BAAA;EACA,kBAjgDc;EAkgDd,yBA7+CuB;EA8+CvB,wCAn+Ce;EAo+Cf,eAAA;EACA,uCAAA;EACA,gBAAA;EACA,wBAAA;EACA,qBAAA;EACA,aAAA;AA9aJ;AAgbI;EACE,aAAA;AA9aN;AAibI;EACE,WAAA;EACA,+BAAA;AA/aN;AAkbI;EACE,4CAAA;AAhbN;AAobE;EACE,8BAAA;AAlbJ;AAqbE;EACE,yBAziDe;AAsnCnB;AAsbE;EACE;IACE,wBAAA;IACA,WAAA;IACA,+BAAA;EApbJ;AACF;AAubE;EACE,cAAA;EACA,aAAA;AArbJ;AAubI;EACE,cAAA;AArbN;AAwbI;EACE,gBAAA;AAtbN;AAybI;EACE,sBAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAvbN;AA0bI;EACE,cAzkDa;EA0kDb,SAAA;AAxbN;AA2bI;EACE,SAAA;EACA,YAAA;EACA,WAAA;EACA,4BAAA;EACA,yDAAA;AAzbN;AA8bI;EACE,gBAAA;AA5bN;AA8bM;EACE,aAAA;AA5bR;AA+bM;EACE,gBAAA;AA7bR;AAgcM;EACE,eAAA;AA9bR;AAicM;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AA/bR;AAicQ;;EAEE,gBAAA;AA/bV;AAmcM;EACE,aAAA;AAjcR;AAocM;EACE,cAAA;EACA,YAAA;AAlcR;AAocQ;EACE,qBAAA;AAlcV;AAocU;EACE,cAAA;AAlcZ;AAwcI;EACE,SAAA;AAtcN;AA2cI;EACE,cA9mDU;AAqqChB;AA4cI;EACE,4BAAA;EACA,yDAAA;AA1cN;AA6cE;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,oCAAA;EACA,gBAAA;EACA,eAjpDkB;EAkpDlB,yBA1nDuB;EA2nDvB,cA9nDY;EA+nDZ,kBAjpDc;EAmpDd,mDAAA;EACA,yBAAA;UAAA,iBAAA;AA3cJ;AA6cI;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,gCAAA;EACA,kCAAA;EACA,uCAAA;EACA,wCAAA;AA3cN;AA8cI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AA5cN;AA+cI;EACE,cAprDa;EAqrDb,SAAA;AA7cN;AAgdI;EACE,cAzrDa;AA2uCnB;AAidI;EACE,cA7rDa;AA8uCnB;AAidM;EACE,eAAA;AA/cR;AAkdM;EACE,YAAA;EACA,kBA1rDU;EA2rDV,wCA3pDW;AA2sCnB;AAodI;EACE,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;AAldN;AAqdI;EACE,iBAAA;EACA,cAAA;AAndN;AAsdI;EACE,cAvtDa;EAwtDb,0CAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;EAIA,YAAA;AAvdN;AA2dE;EACE,yBAtuDe;AA6wCnB;AA2dI;EACE,kCAAA;AAzdN;AA4dI;EAIE,cAhtDqB;AAmvC3B;AAieE;EACE;IACE,gBAAA;EA/dJ;AACF;AAkeE;EACE,aAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAnuDuB;EAouDvB,wCAztDe;EA0tDf,yCAntDkB;EAotDlB,kBA3vDc;EA4vDd,mBAAA;AAheJ;AAkeI;EACE,iBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAhxDa;EAixDb,aAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAzwDY;EA0wDZ,8CAAA;AAheN;AAkeM;EAEE,yBA70DW;EA80DX,cA50DW;AA22CnB;AAqeI;EACE,oBAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;EACA,iDArvDuB;AAkxC7B;AAqeM;EACE,WAAA;EACA,YAAA;AAneR;AAueI;EACE,SAAA;AAreN;AAweI;EACE,qCAAA;EACA,WAAA;EACA,iBAAA;AAteN;AAyeI;EACE,cAAA;AAveN;AA2eE;EACE,yBA3zDe;AAk1CnB;AA2eI;EACE,cA9xDqB;AAqzC3B;AA2eM;EAEE,yBAr3DW;EAs3DX,cAtyDQ;AA4zChB;AA8eE;EACE,yBAx0De;EAy0Df,cAzyDuB;EA0yDvB,wCAhyDiB;EAiyDjB,yCAzxDkB;EA0xDlB,kBAj0Dc;AAq1ClB;AA8eI;EACE,uBAAA;EACA,mBAAA;AA5eN;AAifI;EACE,yBAt1Da;EAu1Db,iDAxyDqB;AAyzC3B;AAkfI;EACE,4BA31Da;EA41Db,+CAAA;AAhfN;AAmfI;EACE,0BAh2Da;EAi2Db,iDAlzDqB;AAi0C3B;AAofI;EACE,2BAr2Da;EAs2Db,+CAAA;AAlfN;AA0fI;EACE,kBAp2DY;EAq2DZ,yBAAA;AAxfN;AA2fI;EACE,yBAp1DqB;EAq1DrB,cAr3Da;AA43CnB;AA4fQ;EACE,yBAz1DiB;AA+1C3B;AA6fQ;EACE,4BA71DiB;AAk2C3B;AA8fQ;EACE,0BAj2DiB;AAq2C3B;AA+fQ;EACE,2BAr2DiB;AAw2C3B;AAugBI;EACE,kBAr4DY;EAs4DZ,yBAAA;AArgBN;AAwgBI;EACE,yBAr3DqB;EAs3DrB,cAt5Da;AAg5CnB;AAygBQ;EACE,yBA13DiB;AAm3C3B;AA0gBQ;EACE,4BA93DiB;AAs3C3B;AA2gBQ;EACE,0BAl4DiB;AAy3C3B;AA4gBQ;EACE,2BAt4DiB;AA43C3B;AA+gBE;EACE,oCAAA;EACA,kCAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AA7gBJ;AA+gBI;EACE,iBAAA;EACA,WAAA;EACA,YAAA;AA7gBN;AAghBI;EACE,iBAAA;EACA,WAAA;EACA,YAAA;AA9gBN;AAihBI;EACE,kBAAA;EACA,YAAA;EACA,aAAA;AA/gBN;AAmhBE;EACE,sCAAA;EACA,oCAAA;AAjhBJ;AAmhBE;EACE,oBAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,wCAx6De;EAy6Df,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBA3gEe;EA4gEf,4BAAA;EACA,kCAAA;EACA,0BAAA;EACA,8CAAA;EACA,gBAAA;AAjhBJ;AAmhBI;EACE,6CAAA;AAjhBN;AAohBI;EACE,cAAA;AAlhBN;AAqhBI;EAEE,yBA3hEa;AAugDnB;AAuhBI;EACE,yDAAA;AArhBN;AAwhBI;EACE,yDAAA;AAthBN;AAyhBI;EACE,0DAAA;AAvhBN;AA0hBI;EACE,0DAAA;AAxhBN;AA2hBI;EACE,0DAAA;AAzhBN;AA4hBI;EACE,0DAAA;AA1hBN;AA6hBI;EACE,0DAAA;AA3hBN;AA8hBE;EACE,cAAA;EACA,WAAA;EACA,iBAAA;EACA,cA3gEe;EA4gEf,yBAhhEe;EAihEf,4BAAA;EACA,yBAAA;EAGA,gBAAA;EACA,kBAxgEc;EAygEd,wEAAA;EACA,aAAA;AA5hBJ;AA8hBI;EACE,yCAAA;EACA,6CAAA;AA5hBN;AA+hBI;EACE,eAAA;EACA,oCAAA;EACA,kBAphEY;AAu/ClB;AAiiBE;EACE,yBAriEe;EAsiEf,yBAAA;AA/hBJ;AAiiBI;EACE,8CAAA;AA/hBN;AAkiBE;EACE,iCAAA;EACA,iBAAA;AAhiBJ;AAkiBI;EACE,oBAAA;EACA,iCAAA;AAhiBN;AAmiBI;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,eAAA;AAjiBN;AAoiBI;EACE,SAAA;EACA,kBAAA;AAliBN;AAqiBI;EACE,cAjkEa;AA8hDnB;AAsiBI;EACE,eAAA;EACA,kBA3jEY;EA4jEZ,yBA1kEa;EA2kEb,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;AApiBN;AAyiBI;EACE,cApjEU;AA6gDhB;AA0iBI;EACE,cArlEa;AA6iDnB;AA2iBE;EACE,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AAziBJ;AA2iBI;EAEE,aAAA;AA1iBN;AA6iBI;EACE,aAAA;EACA,WAAA;EACA,gBAAA;AA3iBN;AA8iBI;EACE,eAAA;EACA,kBAhmEY;EAimEZ,gBAAA;AA5iBN;AA8iBM;EACE,aAAA;AA5iBR;AA+iBM;EACE,gBAAA;AA7iBR;AAgjBM;EACE,aAAA;AA9iBR;AAkjBI;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,eAAA;AAhjBN;AAkjBM;EACE,eAAA;AAhjBR;AAojBI;EACE,iBAAA;EACA,SAAA;EACA,mBAAA;AAljBN;AAqjBI;EACE,oBAAA;AAnjBN;AAsjBI;EACE,SAAA;AApjBN;AAujBI;EACE,cAAA;AArjBN;AAwjBI;EACE,mBAAA;EACA,SAAA;EACA,kBAhpEY;EAipEZ,6BAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;AAtjBN;AA2jBE;EACE,yBAAA;EACA,WAAA;EACA,cAvqEe;EAwqEf,eAAA;AAzjBJ;AA2jBI;EACE,gBAAA;EACA,yBA/qEa;AAsnDnB;AA6jBM;;EAEE,eAAA;EACA,0BAAA;AA3jBR;AA8jBM;EACE,WAAA;AA5jBR;AAikBM;EACE,mBAAA;AA/jBR;AAkkBM;EACE,2BAAA;AAhkBR;AAmkBM;EACE,iCAAA;AAjkBR;AAskBM;EACE,6BAAA;AApkBR;AA0kBQ;EACE,cAAA;AAxkBV;AA6kBQ;EACE,iBAAA;AA3kBV;AAilBE;EACE,cAlsEY;AAmnDhB;AAilBI;EACE,oCAAA;AA/kBN;AAmlBE;EACE,kBA5tEc;EA6tEd,SAAA;EACA,2BAAA;EACA,yBA1sEuB;EA2sEvB,eAAA;EACA,wCAjsEe;AAgnDnB;AAmlBI;EACE,iBAAA;EACA,mBAAA;EACA,qBAjvEa;EAkvEb,cAlvEa;AAiqDnB;AAqlBE;EACE,yBAvvEe;AAoqDnB;AAqlBI;EACE,qBA1tEqB;EA2tErB,cA9tEU;AA2oDhB;AAulBE;EACE,gBAAA;EACA,yBAjuEuB;EAkuEvB,YAAA;EACA,WAAA;EACA,kBAzvEc;EA0vEd,wCA1tEe;AAqoDnB;AAulBI;;EAEE,cAzwEa;EA0wEb,iBAAA;AArlBN;AAwlBI;EAEE,SAAA;EACA,cAAA;AAvlBN;AA0lBI;EACE,YAAA;AAxlBN;AA2lBI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBA7vEqB;EA8vErB,cA9xEa;AAqsDnB;AA2lBM;EAEE,yBAt1EW;EAu1EX,aAAA;AA1lBR;AA+lBE;EACE,yBAzyEe;EA0yEf,mBAAA;AA7lBJ;AA+lBI;;EAEE,cA9wEqB;AAirD3B;AAgmBI;EACE,yBAlzEa;EAmzEb,cAnxEqB;AAqrD3B;AAgmBM;EAEE,yBA12EW;AA2wDnB;AAomBE;EACE,kBAAA;EACA,UAAA;EACA,kBApzEc;AAktDlB;AAomBI;EACE,cAAA;EACA,WAAA;EACA,SAAA;EACA,kBA1zEY;AAwtDlB;AAqmBI;EACE,0BAAA;AAnmBN;AAsmBI;EACE,kBAl0EY;AA8tDlB;AAwmBE;EACE,iBAAA;EACA,oBAAA;EACA,qBAt4Ee;EAu4Ef,0CAAA;AAtmBJ;AAwmBE;EACE,cAAA;AAtmBJ;AAwmBI;EACE,eAAA;EACA,oBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAtmBN;AAymBI;EACE,oBAAA;AAvmBN;AA0mBI;EACE,eAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,4BAAA;EACA,yDAAA;AAxmBN;AA4mBE;EACE,4BAAA;EACA,yDAAA;AA1mBJ;AA6mBE;EACE,WAAA;EACA,gBAAA;EACA,sBAAA;AA3mBJ;AA8mBE;EACE,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;AA5mBJ","sourcesContent":["#map {\r\n  // Colors:\r\n  // Ranges from 100 - 500\r\n  // 200, 300, 400 are the most frequently used\r\n  $color-blue-100: #f0f6ff;\r\n  $color-blue-200: #d7e3fa;\r\n  $color-blue-300: #6397c2;\r\n  $color-blue-400: #0166a5;\r\n  $color-blue-500: #00385b;\r\n  $color-indigo-100: #e7efff;\r\n  $color-indigo-200: #c7d9f8;\r\n  $color-indigo-300: #5b88d6;\r\n  $color-indigo-400: #2357b1;\r\n  $color-indigo-500: #103677;\r\n  $color-purple-100: #e8e6ff;\r\n  $color-purple-200: #d0caff;\r\n  $color-purple-300: #9085e4;\r\n  $color-purple-400: #52489b;\r\n  $color-purple-500: #2e2769;\r\n  $color-pink-100: #feedff;\r\n  $color-pink-200: #fee6ff;\r\n  $color-pink-300: #e8a2ea;\r\n  $color-pink-400: #914594;\r\n  $color-pink-500: #59275a;\r\n  $color-teal-100: #ddfeff;\r\n  $color-teal-200: #bcf8fa;\r\n  $color-teal-300: #56babd;\r\n  $color-teal-400: #00959a;\r\n  $color-teal-500: #005255;\r\n  $color-green-100: #dffffc;\r\n  $color-green-200: #bcfaf4;\r\n  $color-green-300: #3caea3;\r\n  $color-green-400: #007c70;\r\n  $color-green-500: #004942;\r\n  $color-cyan-100: #e0f4ff;\r\n  $color-cyan-200: #ceeeff;\r\n  $color-cyan-300: #68b9e5;\r\n  $color-cyan-400: #0080c5;\r\n  $color-cyan-500: #004367;\r\n  $color-yellow-100: #fff8e1;\r\n  $color-yellow-200: #fae59d;\r\n  $color-yellow-300: #f6d574;\r\n  $color-yellow-400: #fbbd02;\r\n  $color-yellow-500: #493b10;\r\n  $color-orange-100: #ffeddb;\r\n  $color-orange-200: #ffddbc;\r\n  $color-orange-300: #fcbe80;\r\n  $color-orange-400: #f08741;\r\n  $color-orange-500: #6b310a;\r\n  $color-red-100: #ffe6e6;\r\n  $color-red-200: #fdb5b4;\r\n  $color-red-300: #e96b69;\r\n  $color-red-400: #d64b49;\r\n  $color-red-500: #8d2120;\r\n  $color-gray-100: #f3f4f5;\r\n  $color-gray-200: #d3d9e6;\r\n  $color-gray-300: #959dad;\r\n  $color-gray-400: #364159;\r\n  $color-gray-500: #191e29;\r\n\r\n  // Note:\r\n  // To make the contrast higher in both light and dark mode a more\r\n  // vibrant color is needed than is available in the colors above\r\n  $color-link: #0099ff;\r\n\r\n  $top-level-padding: 1.5rem;\r\n  $shadow-focus-width: 3px;\r\n\r\n  $border-radius: 4px;\r\n\r\n  // Device Breakpoints:\r\n  $breakpoint-xxl: 1400px;\r\n  $breakpoint-xl: 1200px;\r\n  $breakpoint-lg: 992px;\r\n  $breakpoint-md: 768px;\r\n  $breakpoint-sm: 576px;\r\n\r\n  // Scroolbar:\r\n  $scrollbar-track-color: #f0f0f0;\r\n  $scrollbar-thumb-color: #cdcdcd;\r\n  $scrollbar-thumb-hover-color: #838383;\r\n\r\n  // OSM-Map:\r\n  $background-map-osm: #aad3df;\r\n\r\n  // Themed Colors:\r\n  $color-light: #ffffff;\r\n  $color-dark: $color-gray-400;\r\n\r\n  $background-theme-light: #ffffff;\r\n  $background-theme-dark: $color-gray-400;\r\n\r\n  $background-theme-light-disabled: rgba($color-gray-200, 0.5);\r\n  $background-theme-dark-disabled: rgba($color-gray-300, 0.3);\r\n\r\n  $form-input-border-color-light: #ced4da;\r\n  $form-input-border-color-dark: #2f3642;\r\n\r\n  // Shadows:\r\n  $box-shadow-light: 1px 1px 0 rgba(0, 0, 0, 0.1);\r\n  $box-shadow-mid: 1px 1px 0 rgba(0, 0, 0, 0.2);\r\n  $box-shadow-dark: 1px 1px 0 rgba(0, 0, 0, 0.3);\r\n\r\n  $drop-shadow-filter-light: drop-shadow(1px 1px 0 rgba(0, 0, 0, 0.1));\r\n  $drop-shadow-filter-mid: drop-shadow(1px 1px 0 rgba(0, 0, 0, 0.2));\r\n  $drop-shadow-filter-dark: drop-shadow(1px 1px 0 rgba(0, 0, 0, 0.3));\r\n\r\n  $text-shadow-light: 1px 1px 0 rgba(0, 0, 0, 0.1);\r\n  $text-shadow-mid: 1px 1px 0 rgba(0, 0, 0, 0.2);\r\n  $text-shadow-dark: 1px 1px 0 rgba(0, 0, 0, 0.3);\r\n\r\n  .oltb-animation {\r\n    animation-duration: 250ms;\r\n    animation-timing-function: linear;\r\n    animation-delay: 0;\r\n    animation-iteration-count: 1;\r\n    animation-direction: normal;\r\n    animation-fill-mode: forwards;\r\n    animation-play-state: running;\r\n\r\n    &--linear-spinner {\r\n      animation-name: oltb-spinner;\r\n      animation-duration: 1500ms;\r\n      animation-iteration-count: infinite;\r\n    }\r\n\r\n    &--bouncy-spinner {\r\n      animation-name: oltb-spinner;\r\n      animation-duration: 1500ms;\r\n      animation-iteration-count: infinite;\r\n    }\r\n\r\n    &--slide-in {\r\n      animation-name: oltb-slide-in;\r\n    }\r\n\r\n    &--slide-out {\r\n      animation-name: oltb-slide-out;\r\n    }\r\n\r\n    &--bounce {\r\n      animation-name: oltb-bounce;\r\n    }\r\n\r\n    &--centered-bounce {\r\n      animation-name: oltb-centered-bounce;\r\n    }\r\n  }\r\n\r\n  @keyframes oltb-spinner {\r\n    0% {\r\n      transform: rotate(0deg);\r\n    }\r\n\r\n    100% {\r\n      transform: rotate(360deg);\r\n    }\r\n  }\r\n\r\n  @keyframes oltb-slide-in {\r\n    0% {\r\n      transform: translateX(100%);\r\n    }\r\n\r\n    100% {\r\n      transform: translateX(0);\r\n    }\r\n  }\r\n\r\n  @keyframes oltb-slide-out {\r\n    0% {\r\n      transform: translateX(0);\r\n    }\r\n\r\n    100% {\r\n      transform: translateX(100%);\r\n    }\r\n  }\r\n\r\n  @keyframes oltb-bounce {\r\n    0% {\r\n      transform: scale(0.95);\r\n    }\r\n\r\n    50% {\r\n      transform: scale(1.05);\r\n    }\r\n\r\n    100% {\r\n      transform: scale(1);\r\n    }\r\n  }\r\n\r\n  @keyframes oltb-centered-bounce {\r\n    0% {\r\n      transform: scale(0.95) translateX(-52.5%);\r\n    }\r\n\r\n    50% {\r\n      transform: scale(1.05) translateX(-47.5%);\r\n    }\r\n\r\n    100% {\r\n      transform: scale(1) translateX(-50%);\r\n    }\r\n  }\r\n\r\n  *,\r\n  *::before,\r\n  *::after {\r\n    -webkit-box-sizing: border-box;\r\n    -moz-box-sizing: border-box;\r\n    box-sizing: border-box;\r\n\r\n    outline: none;\r\n  }\r\n\r\n  // h1,\r\n  // h2,\r\n  // h3,\r\n  // h4,\r\n  // h5,\r\n  // h6,\r\n  // p,\r\n  // img,\r\n  // span,\r\n  // a {\r\n  //   margin: 0 0 1rem 0;\r\n  //   padding: 0;\r\n  // }\r\n\r\n  p {\r\n    font-size: 1.125rem;\r\n  }\r\n\r\n  textarea {\r\n    resize: none;\r\n  }\r\n\r\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\r\n  ::placeholder {\r\n    color: $color-dark;\r\n    opacity: 1;\r\n  }\r\n\r\n  /* Microsoft Edge */\r\n  ::-ms-input-placeholder {\r\n    color: $color-dark;\r\n    opacity: 1;\r\n  }\r\n\r\n  /* Disable blue-highlight on touch devices */\r\n  .oltb-btn,\r\n  .oltb-func-btn,\r\n  .oltb-toggleable {\r\n    -webkit-tap-highlight-color: transparent;\r\n\r\n    &:focus {\r\n      -webkit-tap-highlight-color: transparent;\r\n      -ms-touch-action: manipulation;\r\n      touch-action: manipulation;\r\n      outline: none;\r\n    }\r\n  }\r\n\r\n  .oltb {\r\n    // Margin all sides\r\n    &-m-0 {\r\n      margin: 0 !important;\r\n    }\r\n\r\n    // Margin Top\r\n    &-mt-025 {\r\n      margin-top: 0.25rem !important;\r\n    }\r\n\r\n    &-mt-0313 {\r\n      margin-top: 0.313rem !important;\r\n    }\r\n\r\n    &-mt-05 {\r\n      margin-top: 0.5rem !important;\r\n    }\r\n\r\n    &-mt-0625 {\r\n      margin-top: 0.625rem !important;\r\n    }\r\n\r\n    &-mt-1 {\r\n      margin-top: 1rem !important;\r\n    }\r\n\r\n    &-mt-15 {\r\n      margin-top: 1.5rem !important;\r\n    }\r\n\r\n    // Margin Bottom\r\n    &-mb-025 {\r\n      margin-bottom: 0.25rem !important;\r\n    }\r\n\r\n    &-mb-0313 {\r\n      margin-bottom: 0.313rem !important;\r\n    }\r\n\r\n    &-mb-05 {\r\n      margin-bottom: 0.5rem !important;\r\n    }\r\n\r\n    &-mb-0625 {\r\n      margin-bottom: 0.625rem !important;\r\n    }\r\n\r\n    &-mb-1 {\r\n      margin-bottom: 1rem !important;\r\n    }\r\n\r\n    &-mb-15 {\r\n      margin-bottom: 1.5rem !important;\r\n    }\r\n\r\n    // Margin Left\r\n    &-ml-025 {\r\n      margin-left: 0.25rem !important;\r\n    }\r\n\r\n    &-ml-0313 {\r\n      margin-left: 0.313rem !important;\r\n    }\r\n\r\n    &-ml-05 {\r\n      margin-left: 0.5rem !important;\r\n    }\r\n\r\n    &-ml-0625 {\r\n      margin-left: 0.625rem !important;\r\n    }\r\n\r\n    &-ml-1 {\r\n      margin-left: 1rem !important;\r\n    }\r\n\r\n    &-ml-15 {\r\n      margin-left: 1.5rem !important;\r\n    }\r\n\r\n    // Margin Right\r\n    &-mr-025 {\r\n      margin-right: 0.25rem !important;\r\n    }\r\n\r\n    &-mr-0313 {\r\n      margin-right: 0.313rem !important;\r\n    }\r\n\r\n    &-mr-05 {\r\n      margin-right: 0.5rem !important;\r\n    }\r\n\r\n    &-mr-0625 {\r\n      margin-right: 0.625rem !important;\r\n    }\r\n\r\n    &-mr-1 {\r\n      margin-right: 1rem !important;\r\n    }\r\n\r\n    &-mr-15 {\r\n      margin-right: 1.5rem !important;\r\n    }\r\n\r\n    // Misc\r\n    &-group {\r\n      display: flex;\r\n      flex-direction: row;\r\n      gap: 0.5rem;\r\n\r\n      > * {\r\n        flex: 1;\r\n      }\r\n    }\r\n\r\n    &-w-100 {\r\n      width: 100% !important;\r\n    }\r\n\r\n    &-d-none {\r\n      display: none !important;\r\n    }\r\n\r\n    &-d-flex {\r\n      display: flex !important;\r\n    }\r\n\r\n    &-flex-content-center {\r\n      display: flex;\r\n      flex-direction: column;\r\n      align-items: center;\r\n    }\r\n\r\n    &-text-center {\r\n      text-align: center;\r\n    }\r\n\r\n    &-justify-content-between {\r\n      justify-content: space-between;\r\n    }\r\n\r\n    &-justify-content-center {\r\n      justify-content: center;\r\n    }\r\n\r\n    &-hide-scrollbars {\r\n      -ms-overflow-style: none;\r\n      scrollbar-width: none;\r\n\r\n      &::-webkit-scrollbar {\r\n        display: none;\r\n      }\r\n    }\r\n\r\n    &-thin-scrollbars {\r\n      -ms-overflow-style: none;\r\n      scrollbar-width: thin;\r\n      scrollbar-color: $scrollbar-thumb-color $scrollbar-track-color;\r\n\r\n      &::-webkit-scrollbar {\r\n        width: 0.5rem;\r\n        height: 0.5rem;\r\n        background: $scrollbar-track-color;\r\n        border-top-right-radius: 4px;\r\n        border-bottom-right-radius: 4px;\r\n      }\r\n\r\n      &::-webkit-scrollbar-thumb {\r\n        background-color: $scrollbar-thumb-color;\r\n        border-radius: 1.5rem;\r\n\r\n        &:hover {\r\n          background-color: $scrollbar-thumb-color;\r\n        }\r\n      }\r\n    }\r\n\r\n    &-link {\r\n      color: $color-link;\r\n\r\n      &:focus {\r\n        text-decoration: underline;\r\n      }\r\n    }\r\n  }\r\n\r\n  @import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');\r\n\r\n  html,\r\n  body {\r\n    margin: 0;\r\n    height: 100%;\r\n    font-family: 'Roboto', sans-serif;\r\n  }\r\n\r\n  #map {\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: $background-map-osm;\r\n    position: absolute;\r\n    overflow: hidden;\r\n    user-select: none;\r\n  }\r\n\r\n  .oltb-label {\r\n    display: block;\r\n    color: $color-dark;\r\n    margin-bottom: 0.25rem;\r\n\r\n    &--clickable {\r\n      cursor: pointer;\r\n    }\r\n\r\n    &--inline {\r\n      display: inline;\r\n    }\r\n\r\n    &--inline-block {\r\n      display: inline-block;\r\n    }\r\n  }\r\n\r\n  body.oltb-dark .oltb-label {\r\n    color: $color-light;\r\n  }\r\n\r\n  .oltb-hide {\r\n    display: none !important;\r\n  }\r\n\r\n  .oltb-select {\r\n    display: block;\r\n    width: 100%;\r\n    min-width: 150px;\r\n    padding: 0.25rem 2.25rem 0.25rem 0.5rem;\r\n    font-size: 1rem;\r\n    font-weight: 400;\r\n    line-height: 1.5;\r\n    color: $color-gray-500;\r\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\");\r\n    background-repeat: no-repeat;\r\n    background-position: right 0.75rem center;\r\n    background-size: 16px 12px;\r\n    background-color: $color-gray-100;\r\n    border: 1px solid $form-input-border-color-light;\r\n    border-radius: $border-radius;\r\n    -webkit-appearance: none;\r\n    -moz-appearance: none;\r\n    appearance: none;\r\n    word-wrap: normal;\r\n    outline: none;\r\n\r\n    &:focus {\r\n      border: 1px solid rgba($color-blue-300, 0.5);\r\n      box-shadow: 0 0 0 $shadow-focus-width rgba($color-blue-300, 0.3);\r\n    }\r\n\r\n    &:disabled {\r\n      background-color: $background-theme-light-disabled;\r\n      cursor: not-allowed;\r\n    }\r\n  }\r\n\r\n  body.oltb-dark .oltb-select {\r\n    background-color: $color-gray-300;\r\n    border: 1px solid $form-input-border-color-dark;\r\n\r\n    &:focus {\r\n      box-shadow: 0 0 0 $shadow-focus-width rgba($color-gray-300, 0.5);\r\n    }\r\n\r\n    &:disabled {\r\n      background-color: $background-theme-dark-disabled;\r\n    }\r\n  }\r\n\r\n  .oltb-input {\r\n    display: block;\r\n    width: 100%;\r\n    min-width: 150px;\r\n    padding: 0.375rem 0.75rem;\r\n    font-size: 1rem;\r\n    font-weight: 400;\r\n    line-height: 1.5;\r\n    color: $color-gray-500;\r\n    background-clip: padding-box;\r\n    background-color: $color-gray-100;\r\n    border: 1px solid $form-input-border-color-light;\r\n    -webkit-appearance: none;\r\n    -moz-appearance: none;\r\n    appearance: none;\r\n    border-radius: $border-radius;\r\n    transition: border-color 150ms ease-in-out, box-shadow 150ms ease-in-out;\r\n    outline: none;\r\n\r\n    &:focus {\r\n      border: 1px solid rgba($color-blue-300, 0.5);\r\n      box-shadow: 0 0 0 $shadow-focus-width rgba($color-blue-300, 0.3);\r\n    }\r\n\r\n    &:disabled {\r\n      background-color: $background-theme-light-disabled;\r\n      cursor: not-allowed;\r\n    }\r\n  }\r\n\r\n  .oltb-input-button-group {\r\n    display: flex;\r\n    justify-content: space-evenly;\r\n\r\n    .oltb-input {\r\n      margin-right: 0.5rem;\r\n    }\r\n  }\r\n\r\n  body.oltb-dark .oltb-input {\r\n    background-color: $color-gray-300;\r\n    border: 1px solid $form-input-border-color-dark;\r\n\r\n    &:focus {\r\n      box-shadow: 0 0 0 $shadow-focus-width rgba($color-gray-300, 0.3);\r\n    }\r\n\r\n    &:disabled {\r\n      background-color: $background-theme-dark-disabled;\r\n    }\r\n  }\r\n\r\n  .oltb-btn {\r\n    display: inline-flex;\r\n    flex-shrink: 0;\r\n    justify-content: center;\r\n    align-items: center;\r\n    cursor: pointer;\r\n    user-select: none;\r\n    font-weight: 400;\r\n    text-align: center;\r\n    box-shadow: $box-shadow-mid;\r\n    text-shadow: $text-shadow-light;\r\n    border: none;\r\n    border-radius: $border-radius;\r\n    font-size: 1rem;\r\n    padding: 0.5rem;\r\n    color: $color-light;\r\n    background-color: transparent;\r\n\r\n    &:disabled {\r\n      opacity: 0.5;\r\n      cursor: not-allowed;\r\n    }\r\n\r\n    &__icon {\r\n      filter: $drop-shadow-filter-light;\r\n    }\r\n\r\n    &--round {\r\n      border-radius: 50%;\r\n    }\r\n\r\n    &--blank {\r\n      box-shadow: none;\r\n      padding: 0;\r\n    }\r\n\r\n    &--blue-light {\r\n      background-color: $color-blue-200;\r\n\r\n      &:focus {\r\n        box-shadow: 0 0 0 $shadow-focus-width rgba($color-blue-200, 0.5);\r\n      }\r\n    }\r\n\r\n    &--blue-mid {\r\n      background-color: $color-blue-300;\r\n\r\n      &:focus {\r\n        box-shadow: 0 0 0 $shadow-focus-width rgba($color-blue-300, 0.5);\r\n      }\r\n    }\r\n\r\n    &--blue-dark {\r\n      background-color: $color-blue-400;\r\n\r\n      &:focus {\r\n        box-shadow: 0 0 0 $shadow-focus-width rgba($color-blue-400, 0.5);\r\n      }\r\n    }\r\n\r\n    &--green-light {\r\n      background-color: $color-green-200;\r\n\r\n      &:focus {\r\n        box-shadow: 0 0 0 $shadow-focus-width rgba($color-green-200, 0.5);\r\n      }\r\n    }\r\n\r\n    &--green-mid {\r\n      background-color: $color-green-300;\r\n\r\n      &:focus {\r\n        box-shadow: 0 0 0 $shadow-focus-width rgba($color-green-300, 0.5);\r\n      }\r\n    }\r\n\r\n    &--green-dark {\r\n      background-color: $color-green-400;\r\n\r\n      &:focus {\r\n        box-shadow: 0 0 0 $shadow-focus-width rgba($color-green-400, 0.5);\r\n      }\r\n    }\r\n\r\n    &--red-light {\r\n      background-color: $color-red-200;\r\n\r\n      &:focus {\r\n        box-shadow: 0 0 0 $shadow-focus-width rgba($color-red-200, 0.5);\r\n      }\r\n    }\r\n\r\n    &--red-mid {\r\n      background-color: $color-red-300;\r\n\r\n      &:focus {\r\n        box-shadow: 0 0 0 $shadow-focus-width rgba($color-red-300, 0.5);\r\n      }\r\n    }\r\n\r\n    &--red-dark {\r\n      background-color: $color-red-400;\r\n\r\n      &:focus {\r\n        box-shadow: 0 0 0 $shadow-focus-width rgba($color-red-400, 0.5);\r\n      }\r\n    }\r\n\r\n    &--gray-light {\r\n      background-color: $color-gray-200;\r\n\r\n      &:focus {\r\n        box-shadow: 0 0 0 $shadow-focus-width rgba($color-gray-200, 0.5);\r\n      }\r\n    }\r\n\r\n    &--gray-mid {\r\n      background-color: $color-gray-300;\r\n\r\n      &:focus {\r\n        box-shadow: 0 0 0 $shadow-focus-width rgba($color-gray-300, 0.5);\r\n      }\r\n    }\r\n\r\n    &--gray-dark {\r\n      background-color: $color-dark;\r\n\r\n      &:focus {\r\n        box-shadow: 0 0 0 $shadow-focus-width rgba($color-gray-400, 0.5);\r\n      }\r\n    }\r\n  }\r\n\r\n  body.oltb-using-keyboard .oltb-btn--blank:focus {\r\n    box-shadow: 0 0 0 $shadow-focus-width rgba($color-gray-300, 0.5);\r\n  }\r\n\r\n  .oltb-checkbox-wrapper {\r\n    display: flex;\r\n    align-items: center;\r\n\r\n    &--margin {\r\n      margin-bottom: 1rem;\r\n    }\r\n\r\n    &:last-child {\r\n      margin-bottom: 0;\r\n    }\r\n\r\n    &__checkbox {\r\n      margin: 0.25rem 0.625rem 0.25rem 0;\r\n      width: 1.25rem;\r\n      height: 1.25rem;\r\n      flex-shrink: 0;\r\n      background-color: $background-theme-light;\r\n      background-repeat: no-repeat;\r\n      background-position: center;\r\n      background-size: contain;\r\n      border: 1px solid $form-input-border-color-light;\r\n      -webkit-appearance: none;\r\n      -moz-appearance: none;\r\n      appearance: none;\r\n      -webkit-print-color-adjust: exact;\r\n      print-color-adjust: exact;\r\n      border-radius: $border-radius;\r\n      transition: border-color 150ms ease-in-out, box-shadow 150ms ease-in-out;\r\n\r\n      &:checked {\r\n        background-color: $color-blue-300;\r\n        border-color: $color-blue-300;\r\n      }\r\n\r\n      &:checked[type='checkbox'] {\r\n        background-repeat: no-repeat;\r\n        background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e\");\r\n      }\r\n\r\n      &:focus {\r\n        border: 1px solid $color-blue-300;\r\n        box-shadow: 0 0 0 $shadow-focus-width rgba($color-blue-300, 0.3);\r\n      }\r\n    }\r\n  }\r\n\r\n  body.oltb-dark .oltb-checkbox-wrapper {\r\n    &__title {\r\n      color: $color-light;\r\n    }\r\n\r\n    &__checkbox {\r\n      background-color: $color-gray-300;\r\n      border: none;\r\n\r\n      &:checked {\r\n        background-color: $color-blue-300;\r\n      }\r\n\r\n      &:focus {\r\n        border: none;\r\n        box-shadow: 0 0 0 $shadow-focus-width rgba($color-blue-200, 0.7);\r\n      }\r\n    }\r\n  }\r\n\r\n  .oltb-slider {\r\n    appearance: none;\r\n    -webkit-appearance: none;\r\n    width: 100%;\r\n    height: 0;\r\n    outline: none;\r\n    position: absolute;\r\n    z-index: 700;\r\n    top: 50%;\r\n    left: 0;\r\n    right: 0;\r\n    margin: 0;\r\n    display: none;\r\n\r\n    &--show {\r\n      display: block;\r\n    }\r\n\r\n    // For some reason the ::-webkit-slider-thumb and ::-moz-range-thumb can not be combined into joint syntax.\r\n    // The css is not applied in Chrome and Edge unless the code blocks are separated.\r\n    &::-webkit-slider-thumb {\r\n      width: 2rem;\r\n      height: 2rem;\r\n      border-radius: 50%;\r\n      background-color: $color-blue-300;\r\n      cursor: move;\r\n      box-shadow: 0 0 0 8px rgba(255, 255, 255, 0.9);\r\n      filter: $drop-shadow-filter-mid;\r\n      border: none;\r\n      background-repeat: no-repeat;\r\n      background-position: center center;\r\n      background-size: 24px 24px;\r\n      background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='rgb(255, 255, 255)' viewBox='0 0 16 16'%3E%3Cpath d='M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z'/%3E%3C/svg%3E\");\r\n      -webkit-appearance: none;\r\n    }\r\n\r\n    &::-moz-range-thumb {\r\n      width: 2rem;\r\n      height: 2rem;\r\n      border-radius: 50%;\r\n      background-color: $color-blue-300;\r\n      cursor: move;\r\n      box-shadow: 0 0 0 8px rgba(255, 255, 255, 0.9);\r\n      filter: $drop-shadow-filter-mid;\r\n      border: none;\r\n      background-repeat: no-repeat;\r\n      background-position: center center;\r\n      background-size: 24px 24px;\r\n      background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='rgb(255, 255, 255)' viewBox='0 0 16 16'%3E%3Cpath d='M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z'/%3E%3C/svg%3E\");\r\n    }\r\n  }\r\n\r\n  .oltb-chip {\r\n    display: inline-flex;\r\n    flex-shrink: 0;\r\n    justify-content: center;\r\n    align-items: center;\r\n    cursor: pointer;\r\n    user-select: none;\r\n    font-weight: 400;\r\n    text-align: center;\r\n    text-shadow: $text-shadow-light;\r\n    border: none;\r\n    border-radius: 1rem;\r\n    font-size: 1rem;\r\n    padding: 0.5rem;\r\n    color: $color-light;\r\n    background-color: transparent;\r\n    margin: 0.5rem 0;\r\n\r\n    &:last-child {\r\n      margin-right: 0.5rem;\r\n    }\r\n\r\n    &--deactivated {\r\n      text-decoration: line-through;\r\n      font-style: italic;\r\n    }\r\n\r\n    &--blue-light {\r\n      background-color: $color-blue-200;\r\n\r\n      &:focus {\r\n        box-shadow: 0 0 0 $shadow-focus-width rgba($color-blue-200, 0.5);\r\n      }\r\n    }\r\n\r\n    &--blue-mid {\r\n      background-color: $color-blue-300;\r\n\r\n      &:focus {\r\n        box-shadow: 0 0 0 $shadow-focus-width rgba($color-blue-300, 0.5);\r\n      }\r\n    }\r\n\r\n    &--blue-dark {\r\n      background-color: $color-blue-400;\r\n\r\n      &:focus {\r\n        box-shadow: 0 0 0 $shadow-focus-width rgba($color-blue-400, 0.5);\r\n      }\r\n    }\r\n\r\n    &--green-light {\r\n      background-color: $color-green-200;\r\n\r\n      &:focus {\r\n        box-shadow: 0 0 0 $shadow-focus-width rgba($color-green-200, 0.5);\r\n      }\r\n    }\r\n\r\n    &--green-mid {\r\n      background-color: $color-green-300;\r\n\r\n      &:focus {\r\n        box-shadow: 0 0 0 $shadow-focus-width rgba($color-green-300, 0.5);\r\n      }\r\n    }\r\n\r\n    &--green-dark {\r\n      background-color: $color-green-400;\r\n\r\n      &:focus {\r\n        box-shadow: 0 0 0 $shadow-focus-width rgba($color-green-400, 0.5);\r\n      }\r\n    }\r\n\r\n    &--red-light {\r\n      background-color: $color-red-200;\r\n\r\n      &:focus {\r\n        box-shadow: 0 0 0 $shadow-focus-width rgba($color-red-200, 0.5);\r\n      }\r\n    }\r\n\r\n    &--red-mid {\r\n      background-color: $color-red-300;\r\n\r\n      &:focus {\r\n        box-shadow: 0 0 0 $shadow-focus-width rgba($color-red-300, 0.5);\r\n      }\r\n    }\r\n\r\n    &--red-dark {\r\n      background-color: $color-red-400;\r\n\r\n      &:focus {\r\n        box-shadow: 0 0 0 $shadow-focus-width rgba($color-red-400, 0.5);\r\n      }\r\n    }\r\n\r\n    &--gray-light {\r\n      background-color: $color-gray-200;\r\n\r\n      &:focus {\r\n        box-shadow: 0 0 0 $shadow-focus-width rgba($color-gray-200, 0.5);\r\n      }\r\n    }\r\n\r\n    &--gray-mid {\r\n      background-color: $color-gray-300;\r\n\r\n      &:focus {\r\n        box-shadow: 0 0 0 $shadow-focus-width rgba($color-gray-300, 0.5);\r\n      }\r\n    }\r\n\r\n    &--gray-dark {\r\n      background-color: $color-dark;\r\n\r\n      &:focus {\r\n        box-shadow: 0 0 0 $shadow-focus-width rgba($color-gray-400, 0.5);\r\n      }\r\n    }\r\n  }\r\n\r\n  #oltb {\r\n    position: absolute;\r\n    top: 1rem;\r\n    right: 8px;\r\n    max-height: calc(100% - 2rem);\r\n    display: inline-flex;\r\n    flex-direction: column;\r\n    padding: 0.25rem;\r\n    padding-top: 0;\r\n    background-color: $background-theme-light;\r\n    border-radius: $border-radius;\r\n    box-shadow: $box-shadow-mid;\r\n    overflow: scroll;\r\n    -ms-overflow-style: none;\r\n    scrollbar-width: none;\r\n    transition: transform 450ms ease-in-out;\r\n    transform: translateX(-100%) translateX(-1.25rem);\r\n    opacity: 0.75;\r\n\r\n    &::-webkit-scrollbar {\r\n      display: none;\r\n    }\r\n\r\n    &:empty {\r\n      display: none;\r\n    }\r\n\r\n    &.init-visible {\r\n      transform: translate(0) !important;\r\n    }\r\n\r\n    &.row {\r\n      max-width: calc(100% - 2rem);\r\n      flex-direction: row;\r\n      padding-top: 0.25rem;\r\n      transform: translateY(-100%) translateY(-1.25rem);\r\n\r\n      .oltb-tool-button {\r\n        margin: 0 0 0 0.25rem;\r\n\r\n        &:first-child {\r\n          margin: 0;\r\n        }\r\n      }\r\n    }\r\n\r\n    &.dark {\r\n      background-color: $background-theme-dark;\r\n\r\n      .oltb-tool-button {\r\n        color: $color-light;\r\n\r\n        &:hover,\r\n        &--active {\r\n          background-color: $color-blue-300;\r\n          color: $color-light;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .oltb-tool-button {\r\n    flex-shrink: 0;\r\n    border-radius: $border-radius;\r\n    margin: 0.25rem 0 0 0;\r\n    color: $color-dark;\r\n    height: 2.25rem;\r\n    width: 2.25rem;\r\n    padding: 0;\r\n    background-color: transparent;\r\n    transition: background-color 100ms ease-in-out;\r\n    border: none;\r\n    cursor: pointer;\r\n    position: relative;\r\n\r\n    &:hover,\r\n    &--active {\r\n      background-color: $color-blue-200;\r\n      color: $color-blue-400;\r\n    }\r\n\r\n    &--hidden {\r\n      display: none;\r\n    }\r\n\r\n    &__icon {\r\n      display: inline-block;\r\n      vertical-align: middle;\r\n      filter: $drop-shadow-filter-light;\r\n    }\r\n  }\r\n\r\n  // Note:\r\n  // JavaScript adds the class .using-keyboard to the body tag if the user presses the keyboard\r\n  // If .using-keyboard then enable focus-style to the buttons\r\n  body.oltb-using-keyboard #oltb {\r\n    &.dark {\r\n      .oltb-tool-button {\r\n        &:focus,\r\n        &:active {\r\n          background-color: $color-blue-300;\r\n          color: $color-light;\r\n        }\r\n      }\r\n    }\r\n\r\n    .oltb-tool-button {\r\n      &:focus,\r\n      &:active {\r\n        background-color: $color-blue-200;\r\n        color: $color-blue-400;\r\n      }\r\n    }\r\n  }\r\n\r\n  // Note:\r\n  // Always use horizontal toolbar for mobiles\r\n  @media only screen and (max-width: $breakpoint-sm) {\r\n    #oltb {\r\n      max-width: calc(100% - 2rem);\r\n      flex-direction: row;\r\n      margin-right: 1rem;\r\n      padding-top: 0.25rem;\r\n      top: 3rem;\r\n      right: 0;\r\n    }\r\n\r\n    .oltb-tool-button {\r\n      margin: 0 0 0 0.25rem;\r\n\r\n      &:first-child {\r\n        margin: 0;\r\n      }\r\n    }\r\n  }\r\n\r\n  .oltb-overlay-tooltip {\r\n    display: block;\r\n    background-color: $color-gray-400;\r\n    color: $color-light;\r\n    border-radius: $border-radius;\r\n    -webkit-filter: drop-shadow(1px 1px 0 rgba(0, 0, 0, 0.2));\r\n    filter: drop-shadow(1px 1px 0 rgba(0, 0, 0, 0.2));\r\n    position: relative;\r\n    font-size: 0.9rem;\r\n\r\n    &::before {\r\n      content: '';\r\n      position: absolute;\r\n      bottom: 0;\r\n      left: 50%;\r\n      transform: translate(-50%, 100%);\r\n      border-top: 0.375rem solid $color-gray-400;\r\n      border-right: 0.375rem solid transparent;\r\n      border-left: 0.375rem solid transparent;\r\n    }\r\n\r\n    &--hidden {\r\n      display: none;\r\n    }\r\n\r\n    &__item {\r\n      display: block;\r\n      text-align: center;\r\n      margin: 0;\r\n      padding: 0.25rem 0.5rem;\r\n    }\r\n  }\r\n\r\n  .oltb-overlay-snap {\r\n    display: block;\r\n    position: relative;\r\n\r\n    &__x-line {\r\n      position: absolute;\r\n      top: 50%;\r\n      height: 2px;\r\n      width: 100%;\r\n    }\r\n\r\n    &__y-line {\r\n      position: absolute;\r\n      left: 50%;\r\n      height: 100%;\r\n      width: 2px;\r\n    }\r\n  }\r\n  // Note:\r\n  // Default version, none selected items\r\n\r\n  // Note:\r\n  // Needed to use !important on some locations do override the more specific dark-theme-styles\r\n  .oltb-toolbox-list {\r\n    padding: 0;\r\n    margin: 0 0 0 1rem;\r\n    list-style-type: none;\r\n    position: relative;\r\n\r\n    &::before {\r\n      content: '';\r\n      position: absolute;\r\n      left: 0;\r\n      bottom: 0;\r\n      top: 0;\r\n      margin-left: -0.75rem;\r\n      border: 1px dashed $color-gray-200;\r\n    }\r\n\r\n    &__header {\r\n      cursor: pointer;\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 8px;\r\n      margin-right: auto;\r\n      // max-width: 114px;\r\n      max-width: 100px;\r\n    }\r\n\r\n    &__collapse-icon {\r\n      font-size: 12px;\r\n      transition: transform 0.2s ease;\r\n    }\r\n\r\n    &__wrapper {\r\n      display: flex;\r\n      justify-content: center;\r\n      align-items: center;\r\n    }\r\n\r\n    &__subitem {\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 8px;\r\n      padding: 4px 0;\r\n    }\r\n\r\n    &__sublist {\r\n      flex-basis: 100%; /* ul'yi tam genişlikte yaparak alt satıra geçmesini sağlar */\r\n      // margin: 5px; /* ul ile div'ler arası boşluk */\r\n      // padding: 10px;\r\n      // background-color: lightcoral;\r\n      list-style-type: none;\r\n      margin-left: 15px;\r\n      margin-top: 8px;\r\n      padding-left: 0;\r\n      max-height: 270px;\r\n      overflow: hidden auto;\r\n    }\r\n\r\n    &__dot {\r\n      flex-shrink: 0;\r\n      width: 0.5rem;\r\n      height: 0.5rem;\r\n      margin-right: 0.75rem;\r\n      margin-left: -1.25rem;\r\n      background-color: $color-gray-200;\r\n      border-radius: $border-radius;\r\n      box-shadow: 0 0 0 $shadow-focus-width rgba($color-gray-200, 0.3);\r\n    }\r\n\r\n    &__item {\r\n      flex-wrap: wrap;\r\n      min-height: 33px; // Help when no layer function buttons exists\r\n      padding: 4px;\r\n      margin-bottom: 0.25rem;\r\n      border-radius: $border-radius;\r\n      color: $color-dark;\r\n      font-size: 1rem;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: space-between;\r\n      position: relative;\r\n      border: 1px dashed transparent;\r\n\r\n      &:last-child {\r\n        margin-bottom: 0;\r\n      }\r\n\r\n      // Sortable.js\r\n      // Item is clicked and not dragged yet\r\n      &--chosen {\r\n        color: $color-blue-400;\r\n        border-color: $color-blue-400;\r\n        background-color: $color-blue-200;\r\n      }\r\n\r\n      // Sortable.js\r\n      // Item is beeing dragged\r\n      &--drag {\r\n        color: $color-gray-400;\r\n        border-color: $color-gray-400;\r\n        background-color: $color-gray-200;\r\n\r\n        .oltb-toolbox-list__handle {\r\n          background-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='rgb(59, 67, 82)' viewBox='0 0 16 16'><path d='M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z'/></svg>\") !important;\r\n        }\r\n      }\r\n\r\n      // Sortable.js\r\n      // Item mock to show where it will go after dragged\r\n      &--ghost {\r\n        color: $color-blue-400;\r\n        border-color: $color-blue-400;\r\n        background-color: $color-blue-200;\r\n\r\n        .oltb-toolbox-list__handle {\r\n          background-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='rgb(1, 102, 165)' viewBox='0 0 16 16'><path d='M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z'/></svg>\") !important;\r\n        }\r\n      }\r\n\r\n      &--indicate {\r\n        font-weight: bold;\r\n        color: $color-blue-400 !important;\r\n        border-color: $color-blue-400;\r\n        background-color: $color-blue-200;\r\n\r\n        .oltb-toolbox-list__dot {\r\n          background-color: $color-green-300;\r\n          box-shadow: 0 0 0 $shadow-focus-width rgba($color-green-300, 0.3);\r\n        }\r\n\r\n        .oltb-toolbox-list__handle {\r\n          background-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='rgb(1, 102, 165)' viewBox='0 0 16 16'><path d='M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z'/></svg>\") !important;\r\n        }\r\n      }\r\n    }\r\n\r\n    &__handle {\r\n      width: 10px;\r\n      height: 24px;\r\n      margin-left: 0.5rem;\r\n      cursor: move;\r\n      background-position: calc(100% + 0.5rem);\r\n      background-repeat: no-repeat;\r\n      background-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='rgb(59, 67, 82)' viewBox='0 0 16 16'><path d='M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z'/></svg>\");\r\n    }\r\n\r\n    &__title {\r\n      margin: 0 1rem 0 0;\r\n      cursor: default;\r\n      white-space: nowrap;\r\n      overflow: hidden;\r\n      text-overflow: ellipsis;\r\n      max-width: 100%;\r\n      display: inline-block;\r\n    }\r\n  }\r\n\r\n  // Note:\r\n  // List that can have a selected item, example feature-layers\r\n  .oltb-toolbox-list--selectable .oltb-toolbox-list {\r\n    &__dot {\r\n      cursor: pointer;\r\n    }\r\n\r\n    &__item--active {\r\n      // font-weight: bold;\r\n\r\n      .oltb-toolbox-list__dot {\r\n        background-color: $color-green-300;\r\n        box-shadow: 0 0 0 $shadow-focus-width rgba($color-green-300, 0.3);\r\n      }\r\n    }\r\n\r\n    &__title {\r\n      cursor: pointer;\r\n    }\r\n  }\r\n\r\n  body.oltb-dark .oltb-toolbox-list {\r\n    &__item {\r\n      color: $color-light;\r\n\r\n      &--chosen {\r\n        color: $color-blue-400;\r\n      }\r\n\r\n      &--drag {\r\n        color: $color-gray-400;\r\n      }\r\n\r\n      &--ghost {\r\n        color: $color-blue-400;\r\n      }\r\n    }\r\n\r\n    &__handle {\r\n      background-repeat: no-repeat;\r\n      background-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='rgb(230, 232, 229)' viewBox='0 0 16 16'><path d='M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z'/></svg>\");\r\n    }\r\n  }\r\n  .oltb-modal {\r\n    background-color: $background-theme-light;\r\n    display: inline-block;\r\n    max-width: 1100px;\r\n    min-width: 450px;\r\n    margin: 2rem 1rem;\r\n    padding: $top-level-padding;\r\n    border-radius: $border-radius;\r\n    box-shadow: $box-shadow-dark;\r\n\r\n    &--maximized {\r\n      max-width: 100%;\r\n      width: calc(100% - 2rem);\r\n    }\r\n\r\n    &--push-width {\r\n      width: calc(100% - 2rem);\r\n    }\r\n\r\n    &-backdrop {\r\n      display: block;\r\n      overflow-y: auto;\r\n      position: absolute;\r\n      top: 0;\r\n      left: 0;\r\n      width: 100%;\r\n      height: 100%;\r\n      background-color: rgba(0, 0, 0, 0.6);\r\n      z-index: 900;\r\n      text-align: center;\r\n\r\n      &--fixed {\r\n        position: fixed;\r\n      }\r\n    }\r\n\r\n    &__header {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      align-content: center;\r\n      margin-bottom: 1rem;\r\n    }\r\n\r\n    &__title {\r\n      margin: 0;\r\n      color: $color-dark;\r\n      text-align: left;\r\n    }\r\n\r\n    &__close {\r\n      margin: 0;\r\n      color: $color-dark;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      border-radius: $border-radius;\r\n      width: 1.75rem;\r\n      height: 1.75rem;\r\n    }\r\n\r\n    &__buttons-wrapper {\r\n      margin-top: 1.5rem;\r\n    }\r\n\r\n    &__content {\r\n      text-align: left;\r\n      color: $color-dark;\r\n\r\n      > :last-child {\r\n        margin-bottom: 0 !important;\r\n      }\r\n\r\n      > :first-child {\r\n        margin-top: 0 !important;\r\n      }\r\n    }\r\n  }\r\n\r\n  body.oltb-dark .oltb-modal {\r\n    background-color: $background-theme-dark;\r\n\r\n    &__close,\r\n    &__title,\r\n    &__content {\r\n      color: $color-light;\r\n    }\r\n  }\r\n\r\n  @media only screen and (max-width: $breakpoint-sm) {\r\n    .oltb-modal {\r\n      min-width: calc(100% - 2rem);\r\n    }\r\n  }\r\n  .oltb-dialog {\r\n    background-color: $background-theme-light;\r\n    display: inline-block;\r\n    min-width: 400px;\r\n    max-width: 400px;\r\n    margin: 2rem auto;\r\n    padding: $top-level-padding;\r\n    border-radius: $border-radius;\r\n    box-shadow: $box-shadow-dark;\r\n    color: $color-dark;\r\n\r\n    &-backdrop {\r\n      position: absolute;\r\n      top: 0;\r\n      left: 0;\r\n      width: 100%;\r\n      height: 100%;\r\n      background-color: rgba(0, 0, 0, 0.6);\r\n      z-index: 900;\r\n      text-align: center;\r\n\r\n      &--fixed {\r\n        position: fixed;\r\n      }\r\n    }\r\n\r\n    &__title {\r\n      text-align: left;\r\n    }\r\n\r\n    &__message {\r\n      text-align: left;\r\n    }\r\n\r\n    &__buttons-wrapper {\r\n      text-align: right;\r\n      margin-top: 1.5rem;\r\n    }\r\n\r\n    &__btn {\r\n      padding: 0.5rem 0.625rem;\r\n\r\n      &:last-child {\r\n        margin-left: 0.5rem;\r\n      }\r\n\r\n      &:only-child {\r\n        margin: 0;\r\n      }\r\n    }\r\n  }\r\n\r\n  body.oltb-dark .oltb-dialog {\r\n    background-color: $background-theme-dark;\r\n    color: $color-light;\r\n  }\r\n\r\n  @media only screen and (max-width: $breakpoint-sm) {\r\n    .oltb-dialog {\r\n      min-width: calc(100% - 2rem);\r\n      max-width: calc(100% - 2rem);\r\n    }\r\n  }\r\n  .oltb-toast {\r\n    color: $color-dark;\r\n    background-color: $background-theme-light;\r\n    cursor: default;\r\n    min-width: 320px;\r\n    padding: 0.75rem 0.875rem;\r\n    border-radius: $border-radius;\r\n    box-shadow: $box-shadow-mid;\r\n    margin: 0 1rem 1rem 1rem;\r\n    border-left: 4px solid;\r\n    display: flex;\r\n    align-items: center;\r\n\r\n    &-container {\r\n      position: absolute;\r\n      bottom: 0;\r\n      right: 0;\r\n      overflow-x: hidden;\r\n      z-index: 1000;\r\n    }\r\n\r\n    &__content {\r\n      display: flex;\r\n      flex-direction: column;\r\n      align-items: flex-start;\r\n    }\r\n\r\n    &__title {\r\n      text-shadow: $text-shadow-light;\r\n      margin: 0;\r\n    }\r\n\r\n    &__message {\r\n      font-size: 1rem;\r\n      margin: 0.5rem 0 0 0;\r\n      text-shadow: $text-shadow-light;\r\n\r\n      &:empty {\r\n        display: none;\r\n      }\r\n    }\r\n\r\n    &--clickable {\r\n      cursor: pointer;\r\n    }\r\n\r\n    &--remove {\r\n      margin-right: 0;\r\n    }\r\n\r\n    &--info {\r\n      border-left-color: $color-blue-300;\r\n    }\r\n\r\n    &--warning {\r\n      border-left-color: $color-orange-300;\r\n    }\r\n\r\n    &--error {\r\n      border-left-color: $color-red-300;\r\n    }\r\n\r\n    &--success {\r\n      border-left-color: $color-green-300;\r\n    }\r\n  }\r\n\r\n  body.oltb-dark .oltb-toast {\r\n    color: $color-light;\r\n    background-color: $background-theme-dark;\r\n  }\r\n  .oltb-toolbox-container {\r\n    // Note:\r\n    // min-width is help for collision detection\r\n    min-width: 320px;\r\n    max-width: 410px;\r\n    // max-width: 380px;\r\n    position: absolute;\r\n    pointer-events: auto;\r\n    z-index: 800;\r\n    top: 6rem;\r\n    right: 3.75rem;\r\n    max-height: calc(100% - 2rem);\r\n    border-radius: $border-radius;\r\n    background-color: $background-theme-light;\r\n    box-shadow: $box-shadow-mid;\r\n    padding: 0 1rem;\r\n    transition: transform 450ms ease-in-out;\r\n    overflow-y: auto;\r\n    -ms-overflow-style: none;\r\n    scrollbar-width: none;\r\n    opacity: 0.85;\r\n\r\n    &::-webkit-scrollbar {\r\n      display: none;\r\n    }\r\n\r\n    &--collision {\r\n      top: 4.5rem;\r\n      max-height: calc(100% - 5.5rem);\r\n    }\r\n\r\n    &--hidden {\r\n      transform: translateX(100%) translateX(1rem);\r\n    }\r\n  }\r\n\r\n  .oltb-font-weight-normal {\r\n    font-weight: normal !important;\r\n  }\r\n\r\n  body.oltb-dark .oltb-toolbox-container {\r\n    background-color: $background-theme-dark;\r\n  }\r\n\r\n  @media only screen and (max-width: $breakpoint-sm) {\r\n    .oltb-toolbox-container {\r\n      width: calc(100% - 2rem);\r\n      top: 4.5rem;\r\n      max-height: calc(100% - 5.5rem);\r\n    }\r\n  }\r\n\r\n  .oltb-toolbox-section {\r\n    margin: 1rem 0;\r\n    display: none;\r\n\r\n    &--show {\r\n      display: block;\r\n    }\r\n\r\n    &__header:not(:first-child) {\r\n      margin-top: 1rem;\r\n    }\r\n\r\n    &__header {\r\n      margin: 0 0 0.625rem 0;\r\n      cursor: pointer;\r\n      display: flex;\r\n      justify-content: space-between;\r\n      align-items: center;\r\n    }\r\n\r\n    &__title {\r\n      color: $color-dark;\r\n      margin: 0;\r\n    }\r\n\r\n    &__icon {\r\n      margin: 0;\r\n      height: 16px;\r\n      width: 16px;\r\n      background-repeat: no-repeat;\r\n      background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='rgb(59, 67, 82)' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z'/%3E%3C/svg%3E\");\r\n    }\r\n\r\n    // Note:\r\n    // There is also a global group in _helper-classes.scss\r\n    &__group {\r\n      margin-top: 1rem;\r\n\r\n      &:first-child {\r\n        margin-top: 0;\r\n      }\r\n\r\n      li:first-child:not(.oltb-toolbox-list__subitem) {\r\n        margin-top: 1rem;\r\n      }\r\n\r\n      .oltb-label {\r\n        font-size: 1rem;\r\n      }\r\n\r\n      &--split-group {\r\n        display: flex;\r\n        align-items: end;\r\n        flex-direction: row;\r\n        gap: 0.5rem;\r\n\r\n        .oltb-select,\r\n        .oltb-input {\r\n          min-width: 100px;\r\n        }\r\n      }\r\n\r\n      &--topmost li:first-child {\r\n        margin-top: 0;\r\n      }\r\n\r\n      &--sub-toolbar {\r\n        display: block;\r\n        font-size: 0;\r\n\r\n        .oltb-btn {\r\n          margin-left: 0.375rem;\r\n\r\n          &:first-of-type {\r\n            margin-left: 0;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    &__group-part {\r\n      flex: 1;\r\n    }\r\n  }\r\n\r\n  body.oltb-dark .oltb-toolbox-section {\r\n    &__title {\r\n      color: $color-light;\r\n    }\r\n\r\n    &__icon {\r\n      background-repeat: no-repeat;\r\n      background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='rgb(255, 255, 255)' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z'/%3E%3C/svg%3E\");\r\n    }\r\n  }\r\n  .oltb-info-window {\r\n    position: absolute;\r\n    left: 50%;\r\n    bottom: 0;\r\n    transform: scale(1) translateX(-50%);\r\n    min-width: 360px;\r\n    padding: $top-level-padding;\r\n    background-color: $background-theme-light;\r\n    color: $color-light;\r\n    border-radius: $border-radius;\r\n    -webkit-filter: drop-shadow(0 0 0.25rem rgba(0, 0, 0, 0.4));\r\n    filter: drop-shadow(0 0 0.25rem rgba(0, 0, 0, 0.4));\r\n    user-select: none;\r\n\r\n    &::after {\r\n      content: '';\r\n      position: absolute;\r\n      bottom: 1px;\r\n      left: 50%;\r\n      transform: translate(-50%, 100%);\r\n      border-top: 0.625rem solid $background-theme-light;\r\n      border-left: 0.625rem solid transparent;\r\n      border-right: 0.625rem solid transparent;\r\n    }\r\n\r\n    &__header {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: space-between;\r\n      margin: 0 0 1rem 0;\r\n    }\r\n\r\n    &__title {\r\n      color: $color-dark;\r\n      margin: 0;\r\n    }\r\n\r\n    &__close {\r\n      color: $color-dark;\r\n    }\r\n\r\n    &__content {\r\n      color: $color-dark;\r\n\r\n      p {\r\n        font-size: 1rem;\r\n      }\r\n\r\n      img {\r\n        width: 350px;\r\n        border-radius: $border-radius;\r\n        box-shadow: $box-shadow-mid;\r\n      }\r\n    }\r\n\r\n    &__coordinates {\r\n      margin: 0;\r\n      font-size: 0.8rem;\r\n      white-space: nowrap;\r\n      font-weight: bold;\r\n    }\r\n\r\n    &__buttons-wrapper {\r\n      margin-left: 1rem;\r\n      flex-shrink: 0;\r\n    }\r\n\r\n    &__footer {\r\n      color: $color-dark;\r\n      margin: 1.25rem -0.25rem -0.25rem -0.25rem;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: space-between;\r\n      overflow-x: scroll;\r\n      padding: 0.25rem;\r\n\r\n      // Note:\r\n      // Remove inline-white-space\r\n      font-size: 0;\r\n    }\r\n  }\r\n\r\n  body.oltb-dark .oltb-info-window {\r\n    background-color: $background-theme-dark;\r\n\r\n    &::after {\r\n      border-top: 0.625rem solid $background-theme-dark;\r\n    }\r\n\r\n    &__title,\r\n    &__close,\r\n    &__content,\r\n    &__footer {\r\n      color: $background-theme-light;\r\n    }\r\n  }\r\n\r\n  @media only screen and (max-width: $breakpoint-sm) {\r\n    .oltb-info-window {\r\n      min-width: 330px;\r\n    }\r\n  }\r\n\r\n  .oltb-context-menu {\r\n    display: none;\r\n    list-style: none;\r\n    margin: 0;\r\n    max-width: 250px;\r\n    min-width: 230px;\r\n    padding: 0;\r\n    position: fixed;\r\n    user-select: none;\r\n    background-color: $background-theme-light;\r\n    box-shadow: $box-shadow-mid;\r\n    text-shadow: $text-shadow-light;\r\n    border-radius: $border-radius;\r\n    font-size: 0.875rem;\r\n\r\n    &__item {\r\n      padding: 0.625rem;\r\n      cursor: pointer;\r\n      display: block;\r\n      overflow: hidden;\r\n      text-overflow: ellipsis;\r\n      white-space: nowrap;\r\n      color: $color-dark;\r\n      display: flex;\r\n      align-items: center;\r\n      margin: 0.25rem;\r\n      border-radius: $border-radius;\r\n      transition: background-color 100ms ease-in-out;\r\n\r\n      &:hover,\r\n      &:focus {\r\n        background-color: $color-blue-200;\r\n        color: $color-blue-400;\r\n      }\r\n    }\r\n\r\n    &__icon {\r\n      pointer-events: none;\r\n      display: flex;\r\n      padding-right: 0.625rem;\r\n      margin: 0;\r\n      filter: $drop-shadow-filter-light;\r\n\r\n      svg {\r\n        width: 20px;\r\n        height: 20px;\r\n      }\r\n    }\r\n\r\n    &__text {\r\n      margin: 0;\r\n    }\r\n\r\n    &__divider {\r\n      background-color: rgba(0, 0, 0, 0.15);\r\n      height: 1px;\r\n      margin: 0.25rem 0;\r\n    }\r\n\r\n    &--show {\r\n      display: block;\r\n    }\r\n  }\r\n\r\n  body.oltb-dark .oltb-context-menu {\r\n    background-color: $background-theme-dark;\r\n\r\n    &__item {\r\n      color: $background-theme-light;\r\n\r\n      &:hover,\r\n      &:focus {\r\n        background-color: $color-blue-300;\r\n        color: $color-light;\r\n      }\r\n    }\r\n  }\r\n  .tippy-box[data-theme~='oltb'] {\r\n    background-color: $background-theme-dark;\r\n    color: $background-theme-light;\r\n    box-shadow: $box-shadow-light;\r\n    text-shadow: $text-shadow-light;\r\n    border-radius: $border-radius;\r\n\r\n    .tippy-content {\r\n      padding: 0.25rem 0.5rem;\r\n      font-size: 0.875rem;\r\n    }\r\n  }\r\n\r\n  .tippy-box[data-theme~='oltb'] {\r\n    &[data-placement^='top'] > .tippy-arrow::before {\r\n      border-top-color: $background-theme-dark;\r\n      filter: $drop-shadow-filter-mid;\r\n    }\r\n\r\n    &[data-placement^='bottom'] > .tippy-arrow::before {\r\n      border-bottom-color: $background-theme-dark;\r\n      filter: drop-shadow(1px 0 0 rgba(0, 0, 0, 0.1));\r\n    }\r\n\r\n    &[data-placement^='left'] > .tippy-arrow::before {\r\n      border-left-color: $background-theme-dark;\r\n      filter: $drop-shadow-filter-mid;\r\n    }\r\n\r\n    &[data-placement^='right'] > .tippy-arrow::before {\r\n      border-right-color: $background-theme-dark;\r\n      filter: drop-shadow(0 1px 0 rgba(0, 0, 0, 0.1));\r\n    }\r\n  }\r\n\r\n  body.oltb-dark {\r\n    // Note:\r\n    // This class is added to the popper element in the onShow callback\r\n    // To give the tooltip a bit more constrast\r\n    .tippy-color-picker {\r\n      border-radius: $border-radius;\r\n      border: 1px solid $form-input-border-color-dark;\r\n    }\r\n\r\n    .tippy-box[data-theme~='oltb-themed'] {\r\n      background-color: $background-theme-light;\r\n      color: $background-theme-dark;\r\n\r\n      &.tippy-box[data-theme~='oltb'] {\r\n        &[data-placement^='top'] > .tippy-arrow::before {\r\n          border-top-color: $background-theme-light;\r\n        }\r\n\r\n        &[data-placement^='bottom'] > .tippy-arrow::before {\r\n          border-bottom-color: $background-theme-light;\r\n        }\r\n\r\n        &[data-placement^='left'] > .tippy-arrow::before {\r\n          border-left-color: $background-theme-light;\r\n        }\r\n\r\n        &[data-placement^='right'] > .tippy-arrow::before {\r\n          border-right-color: $background-theme-light;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  body:not(.oltb-dark) {\r\n    // Note:\r\n    // This class is added to the popper element in the onShow callback\r\n    // To give the tooltip a bit more constrast\r\n    .tippy-color-picker {\r\n      border-radius: $border-radius;\r\n      border: 1px solid $form-input-border-color-light;\r\n    }\r\n\r\n    .tippy-box[data-theme~='oltb-inverted-themed'] {\r\n      background-color: $background-theme-light;\r\n      color: $background-theme-dark;\r\n\r\n      &.tippy-box[data-theme~='oltb'] {\r\n        &[data-placement^='top'] > .tippy-arrow::before {\r\n          border-top-color: $background-theme-light;\r\n        }\r\n\r\n        &[data-placement^='bottom'] > .tippy-arrow::before {\r\n          border-bottom-color: $background-theme-light;\r\n        }\r\n\r\n        &[data-placement^='left'] > .tippy-arrow::before {\r\n          border-left-color: $background-theme-light;\r\n        }\r\n\r\n        &[data-placement^='right'] > .tippy-arrow::before {\r\n          border-right-color: $background-theme-light;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .oltb-spinner {\r\n    border-color: rgba(1, 102, 165, 0.3);\r\n    border-top-color: rgba(1, 102, 165, 1);\r\n    border-style: solid;\r\n    border-width: 10px;\r\n    border-radius: 50%;\r\n    flex-shrink: 0;\r\n\r\n    &--small {\r\n      border-width: 3px;\r\n      width: 25px;\r\n      height: 25px;\r\n    }\r\n\r\n    &--medium {\r\n      border-width: 8px;\r\n      width: 50px;\r\n      height: 50px;\r\n    }\r\n\r\n    &--large {\r\n      border-width: 10px;\r\n      width: 100px;\r\n      height: 100px;\r\n    }\r\n  }\r\n\r\n  body.oltb-dark .oltb-spinner {\r\n    border-color: rgba(255, 255, 255, 0.3);\r\n    border-top-color: rgba(255, 255, 255, 1);\r\n  }\r\n  .oltb-func-btn {\r\n    display: inline-flex;\r\n    flex-shrink: 0;\r\n    justify-content: center;\r\n    align-items: center;\r\n    cursor: pointer;\r\n    user-select: none;\r\n    font-weight: 400;\r\n    text-align: center;\r\n    box-shadow: $box-shadow-mid;\r\n    border: none;\r\n    border-radius: 50%;\r\n    width: 1.875rem;\r\n    height: 1.875rem;\r\n    background-color: $color-blue-300;\r\n    background-repeat: no-repeat;\r\n    background-position: center center;\r\n    background-size: 16px 16px;\r\n    transition: background-color 100ms ease-in-out;\r\n    margin-left: 5px;\r\n\r\n    &:focus {\r\n      box-shadow: 0 0 0 $shadow-focus-width rgba($color-blue-300, 0.5);\r\n    }\r\n\r\n    &:first-child {\r\n      margin-left: 0;\r\n    }\r\n\r\n    &:hover,\r\n    &:focus {\r\n      background-color: $color-blue-400;\r\n    }\r\n\r\n    &--crosshair {\r\n      background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='rgb(255, 255, 255)' viewBox='0 0 16 16'%3E%3Cpath d='M8.5.5a.5.5 0 0 0-1 0v.518A7 7 0 0 0 1.018 7.5H.5a.5.5 0 0 0 0 1h.518A7 7 0 0 0 7.5 14.982v.518a.5.5 0 0 0 1 0v-.518A7 7 0 0 0 14.982 8.5h.518a.5.5 0 0 0 0-1h-.518A7 7 0 0 0 8.5 1.018zm-6.48 7A6 6 0 0 1 7.5 2.02v.48a.5.5 0 0 0 1 0v-.48a6 6 0 0 1 5.48 5.48h-.48a.5.5 0 0 0 0 1h.48a6 6 0 0 1-5.48 5.48v-.48a.5.5 0 0 0-1 0v.48A6 6 0 0 1 2.02 8.5h.48a.5.5 0 0 0 0-1zM8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4'/%3E%3C/svg%3E\");\r\n    }\r\n\r\n    &--delete {\r\n      background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='rgb(255, 255, 255)' viewBox='0 0 16 16'%3E%3Cpath d='M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z'/%3E%3Cpath fill-rule='evenodd' d='M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z'/%3E%3C/svg%3E\");\r\n    }\r\n\r\n    &--edit {\r\n      background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='rgb(255, 255, 255)' viewBox='0 0 16 16'%3E%3Cpath d='M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z'/%3E%3C/svg%3E\");\r\n    }\r\n\r\n    &--download {\r\n      background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='rgb(255, 255, 255)' viewBox='0 0 16 16'%3E%3Cpath d='M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z'/%3E%3Cpath d='M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z'/%3E%3C/svg%3E\");\r\n    }\r\n\r\n    &--layer {\r\n      background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='rgb(255, 255, 255)' viewBox='0 0 16 16'%3E%3Cpath d='M8.235 1.559a.5.5 0 0 0-.47 0l-7.5 4a.5.5 0 0 0 0 .882L3.188 8 .264 9.559a.5.5 0 0 0 0 .882l7.5 4a.5.5 0 0 0 .47 0l7.5-4a.5.5 0 0 0 0-.882L12.813 8l2.922-1.559a.5.5 0 0 0 0-.882zm3.515 7.008L14.438 10 8 13.433 1.562 10 4.25 8.567l3.515 1.874a.5.5 0 0 0 .47 0zM8 9.433 1.562 6 8 2.567 14.438 6z'/%3E%3C/svg%3E\");\r\n    }\r\n\r\n    &--geo-pin {\r\n      background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='rgb(255, 255, 255)' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M8 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999zm2.493 8.574a.5.5 0 0 1-.411.575c-.712.118-1.28.295-1.655.493a1.319 1.319 0 0 0-.37.265.301.301 0 0 0-.057.09V14l.002.008a.147.147 0 0 0 .016.033.617.617 0 0 0 .145.15c.165.13.435.27.813.395.751.25 1.82.414 3.024.414s2.273-.163 3.024-.414c.378-.126.648-.265.813-.395a.619.619 0 0 0 .146-.15.148.148 0 0 0 .015-.033L12 14v-.004a.301.301 0 0 0-.057-.09 1.318 1.318 0 0 0-.37-.264c-.376-.198-.943-.375-1.655-.493a.5.5 0 1 1 .164-.986c.77.127 1.452.328 1.957.594C12.5 13 13 13.4 13 14c0 .426-.26.752-.544.977-.29.228-.68.413-1.116.558-.878.293-2.059.465-3.34.465-1.281 0-2.462-.172-3.34-.465-.436-.145-.826-.33-1.116-.558C3.26 14.752 3 14.426 3 14c0-.599.5-1 .961-1.243.505-.266 1.187-.467 1.957-.594a.5.5 0 0 1 .575.411z'/%3E%3C/svg%3E\");\r\n    }\r\n\r\n    &--copy {\r\n      background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='rgb(255, 255, 255)' viewBox='0 0 16 16'%3E%3Cpath d='M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z'/%3E%3Cpath d='M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z'/%3E%3C/svg%3E\");\r\n    }\r\n  }\r\n  .oltb-color-input {\r\n    display: block;\r\n    width: 100%;\r\n    padding: 0.438rem;\r\n    color: $color-gray-500;\r\n    background-color: $color-gray-100;\r\n    background-clip: padding-box;\r\n    border: 1px solid $form-input-border-color-light;\r\n    -webkit-appearance: none;\r\n    -moz-appearance: none;\r\n    appearance: none;\r\n    border-radius: $border-radius;\r\n    transition: border-color 150ms ease-in-out, box-shadow 150ms ease-in-out;\r\n    outline: none;\r\n\r\n    &:focus {\r\n      border: 1px solid rgba($color-blue-300, 0.5);\r\n      box-shadow: 0 0 0 $shadow-focus-width rgba($color-blue-300, 0.3);\r\n    }\r\n\r\n    &__inner {\r\n      padding: 0.5rem;\r\n      border: 1px solid rgba(0, 0, 0, 0.2);\r\n      border-radius: $border-radius;\r\n    }\r\n  }\r\n\r\n  body.oltb-dark .oltb-color-input {\r\n    background-color: $color-gray-300;\r\n    border: 1px solid $form-input-border-color-dark;\r\n\r\n    &:focus {\r\n      box-shadow: 0 0 0 $shadow-focus-width rgba($color-gray-300, 0.5);\r\n    }\r\n  }\r\n  .oltb-debug {\r\n    border-bottom: 1px dashed $color-gray-300;\r\n    padding: 0.5rem 0;\r\n\r\n    &__commands {\r\n      padding-bottom: 1rem;\r\n      border-bottom: 1px dashed $color-gray-300;\r\n    }\r\n\r\n    &__header {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      align-content: center;\r\n      cursor: pointer;\r\n    }\r\n\r\n    &__title {\r\n      margin: 0;\r\n      padding: 0.25rem 0;\r\n    }\r\n\r\n    &__toggle {\r\n      color: $color-dark;\r\n    }\r\n\r\n    &__json {\r\n      padding: 0.5rem;\r\n      border-radius: $border-radius;\r\n      background-color: $color-gray-100;\r\n      border: 1px solid $color-gray-200;\r\n      overflow: auto;\r\n      max-height: 600px;\r\n      font-size: 1rem;\r\n    }\r\n  }\r\n\r\n  body.oltb-dark .oltb-debug {\r\n    &__toggle {\r\n      color: $color-light;\r\n    }\r\n\r\n    &__json {\r\n      color: $color-dark;\r\n    }\r\n  }\r\n  .oltb-log {\r\n    margin: 1rem 0;\r\n    padding: 0 1rem 0 0;\r\n    overflow-y: scroll;\r\n    max-height: 600px;\r\n\r\n    &:empty,\r\n    &--empty {\r\n      display: none;\r\n    }\r\n\r\n    &__filter {\r\n      display: flex;\r\n      gap: 0.5rem;\r\n      overflow: scroll;\r\n    }\r\n\r\n    &__item {\r\n      padding: 0.5rem;\r\n      border-radius: $border-radius;\r\n      margin: 0.5rem 0;\r\n\r\n      &:first-child {\r\n        margin-top: 0;\r\n      }\r\n\r\n      &:last-child {\r\n        margin-bottom: 0;\r\n      }\r\n\r\n      &--hidden {\r\n        display: none;\r\n      }\r\n    }\r\n\r\n    &__header {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      align-content: center;\r\n      cursor: default;\r\n\r\n      &--toggleable {\r\n        cursor: pointer;\r\n      }\r\n    }\r\n\r\n    &__timestamp {\r\n      font-weight: bold;\r\n      margin: 0;\r\n      white-space: nowrap;\r\n    }\r\n\r\n    &__level-icon {\r\n      margin: 0 0.5rem 0 0;\r\n    }\r\n\r\n    &__title {\r\n      margin: 0;\r\n    }\r\n\r\n    &__toggle {\r\n      color: inherit;\r\n    }\r\n\r\n    &__json {\r\n      padding: 1rem 0 0 0;\r\n      margin: 0;\r\n      border-radius: $border-radius;\r\n      background-color: transparent;\r\n      overflow: auto;\r\n      max-height: 300px;\r\n      font-size: 1rem;\r\n    }\r\n  }\r\n  // TODO:\r\n  // Refactor to make it configurable, borders, backgrounds, padding etc.\r\n  .oltb-table {\r\n    border-collapse: collapse;\r\n    width: 100%;\r\n    color: $color-gray-400;\r\n    cursor: default;\r\n\r\n    th {\r\n      text-align: left;\r\n      background-color: $color-gray-100;\r\n    }\r\n\r\n    &--vertical {\r\n      th,\r\n      td {\r\n        padding: 0.5rem;\r\n        border: 1px dashed $color-gray-300;\r\n      }\r\n\r\n      td {\r\n        width: 100%;\r\n      }\r\n    }\r\n\r\n    &--horizontal {\r\n      th {\r\n        padding-top: 0.5rem;\r\n      }\r\n\r\n      td {\r\n        padding: 0.25rem 0 0.5rem 0;\r\n      }\r\n\r\n      tr:not(:last-child):nth-child(2n) > td {\r\n        border-bottom: 1px dashed $color-gray-300;\r\n      }\r\n    }\r\n\r\n    &--no-background {\r\n      th {\r\n        background-color: transparent;\r\n      }\r\n    }\r\n\r\n    &--tight-bottom-and-top {\r\n      tr:first-child {\r\n        th {\r\n          padding-top: 0;\r\n        }\r\n      }\r\n\r\n      tr:last-child {\r\n        td {\r\n          padding-bottom: 0;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  body.oltb-dark .oltb-table {\r\n    color: $color-light;\r\n\r\n    th {\r\n      background-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n  }\r\n  // @Override : default scale-line style from ol\r\n  body .ol-scale-line {\r\n    border-radius: $border-radius;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    background-color: $background-theme-light;\r\n    padding: 0.5rem;\r\n    box-shadow: $box-shadow-mid;\r\n\r\n    &-inner {\r\n      border-width: 2px;\r\n      padding-bottom: 4px;\r\n      border-color: $background-theme-dark;\r\n      color: $background-theme-dark;\r\n    }\r\n  }\r\n\r\n  body.oltb-dark .ol-scale-line {\r\n    background-color: $background-theme-dark;\r\n\r\n    &-inner {\r\n      border-color: $background-theme-light;\r\n      color: $color-light;\r\n    }\r\n  }\r\n  // @Override : default attribution style from ol\r\n  body #map .ol-attribution {\r\n    padding: 0.25rem;\r\n    background-color: $background-theme-light;\r\n    bottom: 1rem;\r\n    right: 1rem;\r\n    border-radius: $border-radius;\r\n    box-shadow: $box-shadow-mid;\r\n\r\n    ul,\r\n    a {\r\n      color: $background-theme-dark;\r\n      text-shadow: none;\r\n    }\r\n\r\n    &-expand,\r\n    &-collapse {\r\n      margin: 0;\r\n      display: block;\r\n    }\r\n\r\n    &-collapse {\r\n      height: 10px;\r\n    }\r\n\r\n    button {\r\n      display: flex;\r\n      justify-content: center;\r\n      align-items: center;\r\n      font-weight: normal;\r\n      cursor: pointer;\r\n      background-color: $background-theme-light;\r\n      color: $background-theme-dark;\r\n\r\n      &:hover,\r\n      &:focus {\r\n        background-color: $color-blue-200;\r\n        outline: none;\r\n      }\r\n    }\r\n  }\r\n\r\n  body.oltb-dark #map .ol-attribution {\r\n    background-color: $background-theme-dark;\r\n    font-weight: normal;\r\n\r\n    ul,\r\n    a {\r\n      color: $background-theme-light;\r\n    }\r\n\r\n    button {\r\n      background-color: $background-theme-dark;\r\n      color: $background-theme-light;\r\n\r\n      &:hover,\r\n      &:focus {\r\n        background-color: $color-blue-300;\r\n      }\r\n    }\r\n  }\r\n  // @Override : default overviewmap style from ol\r\n  #oltb-overview-toolbox .ol-overviewmap {\r\n    position: relative;\r\n    padding: 0;\r\n    border-radius: $border-radius;\r\n\r\n    .ol-overviewmap-map {\r\n      display: block;\r\n      width: 100%;\r\n      margin: 0;\r\n      border-radius: $border-radius;\r\n    }\r\n\r\n    .ol-overviewmap-box {\r\n      border: 2px dotted $color-gray-400;\r\n    }\r\n\r\n    .ol-viewport {\r\n      border-radius: $border-radius;\r\n    }\r\n  }\r\n  // @Override : default dragzoom style from ol\r\n  body .ol-dragzoom {\r\n    border-width: 2px;\r\n    border-style: dashed;\r\n    border-color: $color-blue-400;\r\n    background-color: rgba($color-blue-200, 0.5);\r\n  }\r\n  .oltb-acp {\r\n    display: block;\r\n\r\n    &__header {\r\n      cursor: pointer;\r\n      margin-top: 0.313rem;\r\n      display: flex;\r\n      justify-content: space-between;\r\n      align-items: center;\r\n    }\r\n\r\n    &__title {\r\n      pointer-events: none;\r\n    }\r\n\r\n    &__icon {\r\n      cursor: pointer;\r\n      margin: 0;\r\n      height: 16px;\r\n      width: 16px;\r\n      background-repeat: no-repeat;\r\n      background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='rgb(59, 67, 82)' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z'/%3E%3C/svg%3E\");\r\n    }\r\n  }\r\n\r\n  body.oltb-dark .oltb-acp__icon {\r\n    background-repeat: no-repeat;\r\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='rgb(255, 255, 255)' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z'/%3E%3C/svg%3E\");\r\n  }\r\n\r\n  .oltb-feature-opacity {\r\n    width: 90px;\r\n    margin-left: 8px;\r\n    vertical-align: middle;\r\n  }\r\n\r\n  .oltb-feature-opacity__pct {\r\n    margin-left: 8px;\r\n    min-width: 38px;\r\n    display: inline-block;\r\n    text-align: right;\r\n    opacity: 0.8;\r\n    font-size: 12px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
